import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Data } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HttpService } from '@app/@core/services/http.service';
import { API_ENDPOINTS } from '@app/shared/constants/apiconstants';
import { QUEUE_CONSTANTS } from '@app/shared/constants/queue.constants';
import { DataGridComponent } from '@app/shared/custom-component/data-grid/data-grid.component';
import { DataGridVO } from '@app/shared/custom-component/data-grid/data-grid.model';
import { CommonService } from '@app/shared/services/common.service';
import { forkJoin, Observable, of, Subject } from 'rxjs';
import { map, take, takeUntil, tap } from 'rxjs';
import { AlertService } from '@app/@core/services/alert.service';
import { ModalConfig } from '@app/shared/constants/modal.model';
import { StaffDocumentUploadNoticeModalService } from '@app/shared/services/staff-document-upload-notice-modal.service';
import { getCancelFileUploadModalConfig } from '@app/shared/constants/cancel-file-upload-modal.util';
import { EducatorDuplicateDocumentGuardService } from '@app/shared/services/educator-duplicate-document-guard.service';
import {
  ApplicationOpenFromGridService,
  ApplicationOpenGridRow,
  lookupUserReturnTargets,
  normalizeNumericApplicationId
} from '@app/shared/services/application-open-from-grid.service';
import { ModalComponent } from '@app/shared/custom-component/modal/modal.component';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MatDialog } from '@angular/material/dialog';
import _ from 'lodash';
import * as FileSaver from 'file-saver';
import { MaterialUIModule } from '@app/shared/modules/material-ui/material-ui.module';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { educatorDocumentUploadWithClientBlobPut } from '../../educator-blob-upload.util';
import {
  appendProfileUploadToDashboardRow,
  buildProfileUploadRowForLocalCache,
  toDuplicateLookupOptions
} from '../../educator-duplicate-document.util';
import { ManageProfileService } from '@app/pages/manage-profile/manage-profile.service';
import { LocalService } from '@app/@core/services/local.service';
import {
  canShowDeleteEducatorDocument,
  parseDocumentDeletionStaffHoursFromApi,
  resolveLoginRoleId
} from '../../educator-document-delete-eligibility.util';
import { EducatorDocumentPreviewModalService } from '../../educator-document-preview-modal.service';
import { resolveEducatorDocumentFileUrl } from '../../educator-document-download.util';
import { Dropdown, DropdownModule } from 'primeng/dropdown';
import { flipLookupUploadDropdownAbove } from '../../lookup-upload-dropdown.util';
import { SupportingDocumentRuleConfigService } from '@app/pages/page-designer/supporting-document-rule-config/supporting-document-rule-config.service';
import { SupportingDocumentGridOption } from '@app/pages/page-designer/supporting-document-grid/supporting-document-grid-config.model';
import { LOOKUP_USER_SECTION_FORM_IDS } from '../../lookup-user-form-ids.constants';
import {
  isAcademicBackgroundInstitutionCategory,
  ProfileDocumentLabelContext,
  resolveProfileDocumentCategoryLabel,
  resolveProfileDocumentTypeLabel,
  uniqueSystemACategoryKeysFromDocuments
} from '../../educator-profile-document-labels.util';


@Component({
  selector: 'lookup-user-education-tab',
  standalone: true,
  imports: [CommonModule, DataGridComponent, ReactiveFormsModule, MaterialUIModule, NgxMatSelectSearchModule, DropdownModule],
  templateUrl: './lookup-user-education-tab.component.html',
  styleUrls: ['./lookup-user-education-tab.component.scss']
})
export class LookupUserEducationTabComponent implements OnInit, OnChanges, OnDestroy {
  @Input() educatorDashboardRow: any;
  @Input() personId: string | null = null;
  @Input() tabKey = '';
  @Output() refreshed = new EventEmitter<any>();

  /** Multiplier for converting semester credits to prof-dev hours (loaded from business rules, defaults to 15). */
  semesterCreditMultiplier: number = 15;

  //booleans for sections
  showAcademicBackgroundSection: boolean = false;
  showProfDevCollegeSection: boolean = false;
  showProfDevEmpSection: boolean = false;
  showAdditionalProfDevSection: boolean = false;
  showProgramSection: boolean = false;
  //  booleans to show Columns for Grid
  showAcademicBGColumnChooser: boolean = false;
  showSupportingAbgColumnChooser: boolean = false;
  showProfDevEmpColumnChooser: boolean = false;
  showProfDevEmpSupportColumnChooser: boolean = false
  showAdditionalDevHrsColumnChooser: boolean = false;
  showAdditionalSupportColumnChooser: boolean = false;
  showProgramsColumnChooser: boolean = false;
  showProgramsSupportColumnChooser: boolean = false;
  // booleans to show or hide forms
  showAcademicBGForm: boolean = false;
  showProfDevEmpForm: boolean = false;
  showAdditionalProfDevForm: boolean = false;
  showProgramsForm: boolean = false;
  //  Form Groups
  AcademicBGForm: FormGroup;
  programsForm: FormGroup;
  profDevCourseworkForm: FormGroup;
  profDevCourseworkOriginalValue: string = '';
  get isProfDevCourseworkUnchanged(): boolean {
    return String(this.profDevCourseworkForm?.get('sem_credits_earned')?.value ?? '') === this.profDevCourseworkOriginalValue;
  }
  ProfDevEmploymentForm: FormGroup;
  addtionalProfDevForm: FormGroup;
  currentDate: string = new Date().toISOString().split('T')[0];
  private destroy$ = new Subject<void>();
  @ViewChild(DataGridComponent) dataGridComponent!: DataGridComponent;
  academicBGHeaders: any;
  academicBGSupportingHeaders: any;
  profDevEmpHeaders: any;
  profDevEmpSupportHeaders: any;
  additionalProfDevHeaders: any;
  programsHeaders: any;

  // all columns when loaded component
  allAcadBgColumns: { key: string; label: string; disabled?: boolean }[] = [];
  academicSupportingColumns: { key: string; label: string; disabled?: boolean }[] = [];
  allProfDevEmpColumns: { key: string; label: string; disabled?: boolean }[] = [];
  allAdditionalDevColumns: { key: string; label: string; disabled?: boolean }[] = [];
  allProgramsColumns: { key: string; label: string; disabled?: boolean }[] = [];
  //  visible columns based on user selection
  visibleAllAcademicColumns: { [key: string]: boolean } = {};
  visibleAcademicSupportingColumns: { [key: string]: boolean } = {};
  visibleProfEmpSupportColumns: { [key: string]: boolean } = {};
  visibleProfDevEmpColumns: { [key: string]: boolean } = {};
  visibleProfDevSupportColumns: { [key: string]: boolean } = {};
  visibleAdditonalDevColumns: { [key: string]: boolean } = {};
  visibleAdditionalSupportColumns: { [key: string]: boolean } = {};
  visibleProgramsColumns: { [key: string]: boolean } = {};
  visibleProgramsSupportColumns: { [key: string]: boolean } = {};
  // grids for different tables
  academicBgDataGrid: DataGridVO = new DataGridVO();
  academicBgSupportGrid: DataGridVO = new DataGridVO();
  profDevEmpDataGrid: DataGridVO = new DataGridVO();
  profDevEmpSupportGrid: DataGridVO = new DataGridVO();
  additionalProfDevGrid: DataGridVO = new DataGridVO();
  additionalDevSupportGrid: DataGridVO = new DataGridVO();
  programsGrid: DataGridVO = new DataGridVO();
  programsSupportGrid: DataGridVO = new DataGridVO();
  academicBgRows: Record<string, unknown>[] = [];
  academicSupportRows:  Record<string, unknown>[] = [];
  districtCharterRows:  any[] = [];
  additionalSupportRows:  any[] = [];
  professionalBgRows: any;
  profDevEmploymentRows: Record<string, unknown>[] = [];
  additionalProfDevRows: Record<string, unknown>[] = [];
  data: Record<string, unknown>[] = [];
  // lookups for fetching dropdown values
  institutionLocationLookup: { key: string; value: string }[] = [];
  filteredInstitutionLocations: { key: string; value: string }[] = [];
  institutionLocationFilterCtrl = new FormControl('');
  credentialTypeLookup: { key: string; value: string }[] = [];
  filteredCredentialType: { key: string; value: string }[] = [];
  credentialTypeFilterCtrl = new FormControl('');
  degreeEarnedLookup: { key: string; value: string }[] = [];
  filteredDegreeEarned: { key: string; value: string }[] = [];
  degreeEarnedFilterCtrl = new FormControl('');
  fieldOfStudyLookup: { key: string; value: string }[] = [];
  districtsLookup: { key: string; value: string }[] = [];
  filteredDistrictsLookup: { key: string; value: string }[] = [];
  districtsFilterCtrl = new FormControl('');
  profDevProvidersLookup: { key: string; value: string }[] = [];
  filteredProfDevProviders: { key: string; value: string }[] = [];
  providersFilterCtrl = new FormControl('');
  studentTeachingGradeLookup:{ key: string; value: string }[] = [];
  filteredStudentTeachingGrades: { key: string; value: string }[] = [];
  studentTeachingGradeFilterCtrl = new FormControl('');
  errorMessage: Record<string, string> = {};
  toastMessage: Record<string, string> = {};
  genericMessage: Record<string, string> = {};
  user: any | null = null;
  private uploadModalRef: NgbModalRef | null = null;
  private editAcademicModal: NgbModalRef | null = null;
  currentUploadSection: 'academic-Background' | 'employment_prof_dev' | 'Additional_prof_dev' | 'programs-upload' = 'academic-Background';
  uploadData: any = {
    file: null,
    fileName: '',
    type: ''
  };
  dropzoneActive = false;
  selectedUploadMeta: { fileName: string; contentType: string } = {
    fileName: '',
    contentType: ''
  };
  uploadError: string | null = null;
  saveEnable = true;
  uploadDocMetaForm: FormGroup;
  docCategoryOptions: { id: number; key: string; value: string }[] = [];
  defaultDocCategoryOptions: { id: number; key: string; value: string }[] = [];
  allDocTypeOptions: { id: number; parentid: number | null; key: string; value: string }[] = [];
  uploadFilteredDocTypeOptions: { key: string; value: string }[] = [];
  uploadDocCategoryOptions: SupportingDocumentGridOption[] = [];
  uploadCategoryLabel: string = '';
  allSupportingDocCategories: SupportingDocumentGridOption[] = [];
  private educationSectionCategoryOptions: SupportingDocumentGridOption[] = [];
  private lookupsLoaded = false;
  private metadataLoaded = false;
  private supportingDocTypesCache: Record<string, SupportingDocumentGridOption[]> = {};
  private readonly additionalDevAllowedTypeValues = [
    'Professional Development Certificate',
    'Proof of Completion',
    'Transcripts'
  ];
  private readonly employmentDevAllowedTypeValues = [
    'District / Charter Training Transcript',
    'Professional Development Certificate'
  ];
  @ViewChild('uploadModel') uploadModel!: TemplateRef<any>;
  isEditAcademicBgModal: boolean = false;
  isEditEmploymentDevForm: boolean = false;
  isEditAdditionalDevForm: boolean = false;
  dialogRef: any;
  selectedAcademicBackground: any;
  selectedProgramRow: any;
  selectedEmploymentProf: any;
  selectedAdditionalProf: any;
  profile_documents: Record<string, any> = [];
  /** Flattened normalized supporting-doc rows for Application ID click lookup (internal `id`). */
  private _lastEducationSupportingDocRows: any[] = [];
  programsRows: any[] = [];
  placeholderMessage: Record<string, string> = {};
  isDegreeEarned : boolean = true;
  showButtons:boolean = true;
  isGreaterthanHighSchool :boolean =false;

  // Transcript-related properties
  transcriptRowData: any = null;
  transcriptMessage: SafeHtml | string = '';
  private transcriptModalRef: NgbModalRef | null = null;
  private pendingTranscriptUpdates = new Set<any>();
  private onDocumentUploaded = (event: any) => {
    const category = String(event?.detail?.category || '').trim();
    if (category !== '10') return;
    this.triggerAutoTranscriptUpdate();
  };

  /** BR0036 */
  documentDeletionStaffHours: number | null = null;

  constructor(
    private commonService: CommonService,
    private dialog: MatDialog,
    private modalService: NgbModal,
    private staffDocNoticeModal: StaffDocumentUploadNoticeModalService,
    private duplicateDocGuard: EducatorDuplicateDocumentGuardService,
    private activateRoute: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private alertService: AlertService,
    private fb: FormBuilder,
    private httpService: HttpService,
    private applicationOpenFromGrid: ApplicationOpenFromGridService,
    private manageProfileService: ManageProfileService,
    private localService: LocalService,
    private documentPreviewModal: EducatorDocumentPreviewModalService,
    private supportingDocLookupService: SupportingDocumentRuleConfigService,
    private sanitized: DomSanitizer
  ) {}

  ngOnChanges(_: SimpleChanges): void {
    this.rebuildEducationGridsIfReady();
  }

  ngOnInit(): void {
    this.user = JSON.parse(window.sessionStorage.getItem('user'));
    window.addEventListener('supporting-document-uploaded', this.onDocumentUploaded);
    this.loadSemesterCreditMultiplier();
    this.manageProfileService
      .getBusinessRuleByKey('Documents', 'document_deletion_time_left')
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (res: unknown) => {
          this.documentDeletionStaffHours = parseDocumentDeletionStaffHoursFromApi(res);
        },
        error: () => {
          this.documentDeletionStaffHours = null;
        }
      });
    this.loadDropdownValues()
    this.AcademicBGForm = this.fb.group({
      institution_name: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(60), Validators.pattern(/^[A-Za-z\s.,\-&'()/]{2,60}$/)]),

      institution_location: new FormControl(null, Validators.required),
      credential_type: new FormControl(null, Validators.required),
      degree_earned: new FormControl(null, Validators.required),
      completion_date: new FormControl(null, [Validators.required, this.validateDate, this.validateDateNotBeforeDob]),
      credit_earned: new FormControl(null, [Validators.required, Validators.max(100)]),
      cd_major_minor: new FormControl(null, Validators.required),
      field_of_study: new FormControl(null, [Validators.required, Validators.minLength(2), Validators.maxLength(60), Validators.pattern(/^[A-Za-z\s.,\-&()/]{2,60}$/)]),

      student_credits_earned: new FormControl(''),
      student_grade_level: new FormControl(null)

    });
    this.programsForm = this.fb.group({
      separation_date: new FormControl(''),
      notes: new FormControl('')
    })
    this.profDevCourseworkForm = new FormGroup({
      sem_credits_earned: new FormControl('', [Validators.required, Validators.pattern(/^\d*\.?\d{0,2}$/), (control) => {
        const val = parseFloat(control.value);
        return !isNaN(val) && val <= 0 ? { minValue: true } : null;
      }, (control) => {
        const val = parseFloat(control.value);
        return !isNaN(val) && val > 999.99 ? { maxValue: true } : null;
      }]),
      prof_dev_hrs: new FormControl({ value: '', disabled: true })
    })
    this.ProfDevEmploymentForm = new FormGroup({
      district_charter_name: new FormControl(null, Validators.required),
      district_charter_prof_dev_hrs: new FormControl('', [Validators.required, Validators.min(0.01)])
    })
    this.addtionalProfDevForm = new FormGroup({
      provider_name: new FormControl(null, Validators.required),
      additional_prof_dev_hrs: new FormControl('', [Validators.required, Validators.min(0.01)]),
    })
    this.uploadDocMetaForm = this.fb.group({
      category: ['', Validators.required],
      type: ['', Validators.required]
    });
    this.AcademicBGForm.get('degree_earned')?.valueChanges.subscribe(value=>{
      const completionDateControl = this.AcademicBGForm.get('completion_date');
      const credTypeControl = this.AcademicBGForm.get('credential_type');
      const creditsEarnedControl = this.AcademicBGForm.get('credit_earned');
      if(value === '1'){
        this.isDegreeEarned= false;
        completionDateControl?.clearValidators();
        completionDateControl.setValue(null);
        credTypeControl.clearValidators();
        creditsEarnedControl.setValidators([Validators.required, Validators.max(100)])
      }else {
        this.isDegreeEarned= true
        completionDateControl.setValidators([Validators.required, this.validateDate, this.validateDateNotBeforeDob]);
        credTypeControl.setValidators(Validators.required);
        creditsEarnedControl.clearValidators();
        creditsEarnedControl.setValue(null);
      }
      completionDateControl?.updateValueAndValidity();
      credTypeControl?.updateValueAndValidity();
      creditsEarnedControl?.updateValueAndValidity();
    })
    this.AcademicBGForm?.get('credential_type')?.valueChanges.subscribe(value =>{
      const credntialObject = this.credentialTypeLookup.find((item:any) => item.value === 'High School Diploma or Equivalent');
      const credentialKey = Number(value)
      this.isGreaterthanHighSchool = credentialKey > Number(credntialObject.key) ;
       const fieldOfstudyControl = this.AcademicBGForm.get('cd_major_minor');
       const programNameControl = this.AcademicBGForm.get('field_of_study')
      if(!this.isGreaterthanHighSchool){
       fieldOfstudyControl.clearValidators();
       fieldOfstudyControl.setValue(null);
       programNameControl.clearValidators();
       programNameControl.setValue(null)
      }else{
        fieldOfstudyControl.setValidators(Validators.required),
        programNameControl.setValidators([Validators.required, Validators.minLength(2), Validators.maxLength(60), Validators.pattern(/^[A-Za-z\s.,\-&'()/]{2,60}$/)])
      }
      fieldOfstudyControl.updateValueAndValidity();
      programNameControl.updateValueAndValidity();
    })
    this.profDevCourseworkForm.get('sem_credits_earned')?.valueChanges.subscribe((val) => {
      if (val && /^\d*\.?\d{0,2}$/.test(val) && parseFloat(val) > 0) {
        this.profDevCourseworkForm.get('prof_dev_hrs').setValue(parseFloat((parseFloat(val) * this.semesterCreditMultiplier).toFixed(2)));
      } else {
        this.profDevCourseworkForm.get('prof_dev_hrs').setValue('');
      }
    })
    this.commonService.getMetaData(QUEUE_CONSTANTS.USER_EDUCATION).
      pipe(take(1), takeUntil(this.destroy$)).subscribe((res: any) => {
        this.academicBGHeaders = res.academicBGGrid;
        this.academicBGSupportingHeaders = res.academicBgSupportingDocGrid;
        this.profDevEmpHeaders = res.professionalDevelopmentEmploymentGrid.map((h: any) =>
          h.dataField === 'district_charter_prof_dev_hrs' ? { ...h, dataField: 'district_charter_prof_dev_hrs_display' } : h
        );
        this.additionalProfDevHeaders = res.additionalProfDevHrsGrid.map((h: any) =>
          h.dataField === 'additional_prof_dev_hrs' ? { ...h, dataField: 'additional_prof_dev_hrs_display' } : h
        );
        this.programsHeaders = res.programsGrid;
        if (Array.isArray(res.programsGrid)) {
          this.allProgramsColumns = res.programsGrid.map((h: any) => ({
            key: h.dataField,
            label: h.caption || h.dataField
          }));
          this.lockFirstColumn(this.allProgramsColumns);
        }
        if (!this.visibleProgramsColumns) {
          this.visibleProgramsColumns = {};
        }
        this.allProgramsColumns.forEach(c => {
          if (typeof this.visibleProgramsColumns[c.key] === 'undefined') {
            this.visibleProgramsColumns[c.key] = true;
          }
        });

        if (Array.isArray(res.academicBGGrid)) {
          this.allAcadBgColumns = res.academicBGGrid.map((h: any) => ({
            key: h.dataField,
            label: h.caption || h.dataField
          }));
          this.lockFirstColumn(this.allAcadBgColumns);
        }
        if (!this.visibleAllAcademicColumns) {
          this.visibleAllAcademicColumns = {};
        }
        this.allAcadBgColumns.forEach(c => {
          if (typeof this.visibleAllAcademicColumns[c.key] === 'undefined') {
            this.visibleAllAcademicColumns[c.key] = true;
          }
        });

        if (Array.isArray(res.additionalProfDevHrsGrid)) {
          this.allAdditionalDevColumns = res.additionalProfDevHrsGrid.map((h: any) => ({
            key: h.dataField,
            label: h.caption || h.dataField
          }));
          this.lockFirstColumn(this.allAdditionalDevColumns);
        }
        if (!this.visibleAdditonalDevColumns) {
          this.visibleAdditonalDevColumns = {};
        }
        this.allAdditionalDevColumns.forEach(c => {
          if (typeof this.visibleAdditonalDevColumns[c.key] === 'undefined') {
            this.visibleAdditonalDevColumns[c.key] = true;
          }
        });

        if (Array.isArray(res.professionalDevelopmentEmploymentGrid)) {
          this.allProfDevEmpColumns = res.professionalDevelopmentEmploymentGrid.map((h: any) => ({
            key: h.dataField,
            label: h.caption || h.dataField
          }));
          this.lockFirstColumn(this.allProfDevEmpColumns);
        }
        if (!this.visibleProfDevEmpColumns) {
          this.visibleProfDevEmpColumns = {}
        }
        this.allProfDevEmpColumns.forEach(c => {
          if (typeof this.visibleProfDevEmpColumns[c.key] === 'undefined') {
            this.visibleProfDevEmpColumns[c.key] = true;
          }
        })

        if (Array.isArray(res.academicBgSupportingDocGrid)) {
          this.academicSupportingColumns = res.academicBgSupportingDocGrid.map((h: any) => ({
            key: h.dataField,
            label: h.caption || h.dataField
          }));
          this.lockFirstColumn(this.academicSupportingColumns);
        }
        if (!this.visibleAcademicSupportingColumns) {
          this.visibleAcademicSupportingColumns = {}
        }
        this.academicSupportingColumns.forEach(c => {
          if (typeof this.visibleAcademicSupportingColumns[c.key] === 'undefined') {
            this.visibleAcademicSupportingColumns[c.key] = true;
            this.visibleAdditionalSupportColumns[c.key] = true;
            this.visibleProfDevSupportColumns[c.key] = true;
            this.visibleProgramsSupportColumns[c.key] = true;
          }
        })
        this.metadataLoaded = true;
        this.rebuildEducationGridsIfReady();
      });
  }
  selectedGridForUpload: 'academic-Background' | 'employment_prof_dev' | 'Additional_prof_dev' | 'programs-upload' = 'academic-Background'
  private openUploadModalAfterNotice(): void {
    this.currentUploadSection = this.selectedGridForUpload;
    this.uploadData = { file: null, fileName: '', type: '' };
    this.uploadError = null;
    this.saveEnable = true;
    this.uploadDocCategoryOptions = [];
    this.uploadFilteredDocTypeOptions = [];
    this.uploadCategoryLabel = '';
    this.uploadDocMetaForm.reset({ category: '', type: '' });
    this.uploadModalRef = this.modalService.open(this.uploadModel, { windowClass: 'lookup-education-doc-modal', centered: true, backdrop: 'static', keyboard: false });
    this.supportingDocLookupService
      .getAllTopLevelCategories()
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe((cats: SupportingDocumentGridOption[]) => {
        this.uploadDocCategoryOptions = cats;
        if (!this.allSupportingDocCategories.length) {
          this.allSupportingDocCategories = cats;
        }
        this.configureUploadMetaOptionsForSection();
      });
  }

  onUploadTypeDropdownShow(dropdown: Dropdown): void {
    flipLookupUploadDropdownAbove(dropdown);
  }

  closeUploadPopup(): void {
    // Only check user-entered values: file and type (category is often pre-populated and disabled)
    const typeVal = this.uploadDocMetaForm.get('type')?.value;
    const categoryEnabled = this.uploadDocMetaForm.get('category')?.enabled;
    const categoryVal = categoryEnabled ? this.uploadDocMetaForm.get('category')?.value : null;

    const hasDraft = !!(
      this.uploadData?.file ||
      (typeVal != null && String(typeVal).trim() !== '') ||
      (categoryVal != null && String(categoryVal).trim() !== '')
    );

    if (hasDraft) {
      const modalRef = this.modalService.open(ModalComponent, {
        size: 'md',
        centered: true,
        backdrop: 'static'
      });
      modalRef.componentInstance.modalConfig = getCancelFileUploadModalConfig();
      modalRef.componentInstance.emitData.pipe(take(1)).subscribe((result: any) => {
        modalRef.close();
        if (result?.code === 'Y' || result?.confirmed === true) {
          this._actuallyCloseUploadPopup();
        }
      });
    } else {
      this._actuallyCloseUploadPopup();
    }
  }

  private _actuallyCloseUploadPopup(): void {
    this.uploadModalRef?.close();
    this.uploadModalRef = null;
    this.uploadData = { file: null, fileName: '', type: '' };
    this.uploadError = null;
    this.saveEnable = true;
    this.dropzoneActive = false;
    this.uploadDocMetaForm.reset({ category: '', type: '' });
    this.uploadDocCategoryOptions = [];
    this.uploadFilteredDocTypeOptions = [];
    this.uploadCategoryLabel = '';
  }

  onUploadDocCategoryChange(): void {
    const key = this.uploadDocMetaForm.get('category')?.value;
    this.uploadDocMetaForm.patchValue({ type: '' });
    if (!key) {
      this.uploadFilteredDocTypeOptions = [];
      return;
    }
    // academic-Background: type depends on selected category (grid vs CMS children)
    if (this.currentUploadSection === 'academic-Background') {
      const selectedCat = this.uploadDocCategoryOptions.find((c) => c.key === key);
      if (!selectedCat) {
        this.uploadFilteredDocTypeOptions = [];
        return;
      }
      if (isAcademicBackgroundInstitutionCategory(key, this.getProfileDocumentLabelContext())) {
        this.uploadFilteredDocTypeOptions = this.getTypeOptionsForCategory('academic-Background');
      } else {
        this.supportingDocLookupService
          .getTypesByCategory(selectedCat)
          .pipe(take(1), takeUntil(this.destroy$))
          .subscribe((types: SupportingDocumentGridOption[]) => {
            this.supportingDocTypesCache[key] = types;
            this.uploadFilteredDocTypeOptions = types.map((t) => ({ key: t.key, value: t.value }));
          });
      }
      return;
    }
    // employment_prof_dev: district/charter names from rows
    if (this.currentUploadSection === 'employment_prof_dev') {
      const names = [...new Set(
        (this.profDevEmploymentRows || [])
          .map((r: any) => String(r?.district_charter_name ?? '').trim())
          .filter(Boolean)
      )].sort();
      this.uploadFilteredDocTypeOptions = names.map(n => ({ key: n, value: n }));
      return;
    }
    // Additional_prof_dev: provider names from rows
    if (this.currentUploadSection === 'Additional_prof_dev') {
      const names = [...new Set(
        (this.additionalProfDevRows || [])
          .map((r: any) => String(r?.provider_name ?? '').trim())
          .filter(Boolean)
      )].sort();
      this.uploadFilteredDocTypeOptions = names.map(n => ({ key: n, value: n }));
      return;
    }
    // programs-upload and any other section: use service
    const selectedCat = this.uploadDocCategoryOptions.find(c => c.key === key);
    if (!selectedCat) {
      this.uploadFilteredDocTypeOptions = [];
      return;
    }
    this.supportingDocLookupService
      .getTypesByCategory(selectedCat)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe((types: SupportingDocumentGridOption[]) => {
        this.uploadFilteredDocTypeOptions = types.map(t => ({ key: t.key, value: t.value }));
      });
  }

  private buildUploadCategoryOptions(): Array<{ id: number; key: string; value: string }> {
    // kept for legacy callers; new flow uses uploadDocCategoryOptions from SupportingDocumentRuleConfigService
    return [];
  }
  private _legacyBuildUploadCategoryOptions(): Array<{ id: number; key: string; value: string }> {
    if (this.currentUploadSection === 'academic-Background') {
      const match = this.docCategoryOptions.find(c =>
        c.value === 'Academic Background' || c.key === 'Academic Background'
      );
      return match ? [match] : [{ id: 1, key: 'Academic Background', value: 'Academic Background' }];
    }
    if (this.currentUploadSection === 'Additional_prof_dev') {
      const names = (this.additionalProfDevRows || [])
        .map((row: any) => String(row?.provider_name ?? '').trim())
        .filter(n => n !== '');
      const unique = [...new Set(names)];
      return unique.map((n, i) => ({ id: i + 1, key: n, value: n }));
    }
    if (this.currentUploadSection === 'employment_prof_dev') {
      const names = (this.profDevEmploymentRows || [])
        .map((row: any) => String(row?.district_charter_name ?? '').trim())
        .filter(n => n !== '');
      const unique = [...new Set(names)];
      return unique.map((n, i) => ({ id: i + 1, key: n, value: n }));
    }
    return this.defaultDocCategoryOptions.length ? [...this.defaultDocCategoryOptions] : [...this.docCategoryOptions];
  }

  private configureUploadMetaOptionsForSection(): void {
    // Maps upload section key → optionaldata.section_name stored in the DB lookup
    const sectionNameMap: Record<string, string> = {
      'academic-Background': 'Academic Background',
      'employment_prof_dev': 'District / Charter Employment',
      'Additional_prof_dev': 'Additional Professional Development',
      'programs-upload': 'Programs'
    };
    const sectionName = sectionNameMap[this.currentUploadSection];
    if (!sectionName) {
      this.uploadCategoryLabel = '';
      this.uploadDocMetaForm.get('category')?.enable();
      this.uploadFilteredDocTypeOptions = [];
      return;
    }

    // Filter categories from service to only those belonging to this section
    const sectionCats = this.uploadDocCategoryOptions.filter(c =>
      String(c.optionaldata?.section_name ?? '').trim() === sectionName
    );
    this.uploadDocCategoryOptions = sectionCats.length ? sectionCats : this.uploadDocCategoryOptions;

    if (this.currentUploadSection === 'academic-Background') {
      this.uploadCategoryLabel = '';
      this.uploadDocMetaForm.get('category')?.enable();
      this.uploadFilteredDocTypeOptions = [];
    } else if (this.currentUploadSection === 'employment_prof_dev') {
      // Category: service options filtered by section_name; Type: district/charter names from rows
      this.uploadCategoryLabel = '';
      this.uploadDocMetaForm.get('category')?.enable();
      const names = [...new Set(
        (this.profDevEmploymentRows || [])
          .map((r: any) => String(r?.district_charter_name ?? '').trim())
          .filter(Boolean)
      )].sort();
      this.uploadFilteredDocTypeOptions = names.map(n => ({ key: n, value: n }));
    } else if (this.currentUploadSection === 'Additional_prof_dev') {
      // Category: service options filtered by section_name; Type: provider names from rows
      this.uploadCategoryLabel = '';
      this.uploadDocMetaForm.get('category')?.enable();
      const names = [...new Set(
        (this.additionalProfDevRows || [])
          .map((r: any) => String(r?.provider_name ?? '').trim())
          .filter(Boolean)
      )].sort();
      this.uploadFilteredDocTypeOptions = names.map(n => ({ key: n, value: n }));
    } else {
      // programs-upload / other: free dropdown, types load on category selection
      this.uploadCategoryLabel = '';
      this.uploadDocMetaForm.get('category')?.enable();
      this.uploadFilteredDocTypeOptions = [];
    }
  }

  /**
   * Returns document type options for a given upload section.
   * Only used for academic-Background (institution names from rows).
   * All other sections load types via getTypesByCategory() from the service.
   */
  private getTypeOptionsForCategory(sectionOrCategoryValue: string): { key: string; value: string }[] {
    switch (sectionOrCategoryValue) {
      case 'academic-Background':
      case 'Academic Background': {
        const names = [...new Set(
          (this.academicBgRows || [])
            .map((r: any) => String(r?.institution_name ?? '').trim())
            .filter(Boolean)
        )].sort();
        return names.map(n => ({ key: n, value: n }));
      }
      default: {
        // Programs / fallback: filter allDocTypeOptions by parent category id
        const legacyCat = this.docCategoryOptions.find(
          c => c.value === sectionOrCategoryValue || c.key === sectionOrCategoryValue
        );
        if (legacyCat) {
          const children = this.allDocTypeOptions.filter(t => t.parentid === legacyCat.id);
          if (children.length) return children.map(t => ({ key: t.key, value: t.value }));
        }
        return this.allDocTypeOptions.map(t => ({ key: t.key, value: t.value }));
      }
    }
  }

  private getSectionScopedTypeOptions(): { id: number; parentid: number | null; key: string; value: string }[] {
    if (this.currentUploadSection === 'academic-Background') {
      return this.getAcademicBgTypeOptions();
    }
    if (this.currentUploadSection === 'Additional_prof_dev') {
      return this.getAdditionalDevTypeOptions();
    }
    if (this.currentUploadSection === 'employment_prof_dev') {
      return this.getEmploymentDevTypeOptions();
    }
    return [...this.allDocTypeOptions];
  }

  private getAdditionalDevTypeOptions(): { id: number; parentid: number | null; key: string; value: string }[] {
    const allowed = new Set(this.additionalDevAllowedTypeValues);
    const filteredFromLookup = (this.allDocTypeOptions || []).filter((type) => allowed.has(String(type?.value ?? '').trim()));
    if (filteredFromLookup.length > 0) {
      return filteredFromLookup;
    }
    return this.additionalDevAllowedTypeValues.map((value, index) => ({
      id: index + 1,
      parentid: null,
      key: value,
      value
    }));
  }

  private getEmploymentDevTypeOptions(): { id: number; parentid: number | null; key: string; value: string }[] {
    const allowed = new Set(this.employmentDevAllowedTypeValues);
    const filteredFromLookup = (this.allDocTypeOptions || []).filter((type) => allowed.has(String(type?.value ?? '').trim()));
    if (filteredFromLookup.length > 0) {
      return filteredFromLookup;
    }
    return this.employmentDevAllowedTypeValues.map((value, index) => ({
      id: index + 1,
      parentid: null,
      key: value,
      value
    }));
  }

  private getAcademicBgTypeOptions(): { id: number; parentid: number | null; key: string; value: string }[] {
    const names = (this.academicBgRows || [])
      .map((row: any) => String(row?.institution_name ?? '').trim())
      .filter(name => name !== '');
    const unique = [...new Set(names)];
    return unique.map((name, index) => ({
      id: index + 1,
      parentid: null,
      key: name,
      value: name
    }));
  }

  private resolveSelectedUploadCategory(): string | null {
    const selectedKey = String(this.uploadDocMetaForm.get('category')?.value ?? '').trim();
    if (!selectedKey) {
      return null;
    }
    if (this.uploadCategoryLabel) {
      return this.uploadCategoryLabel;
    }
    const match = this.uploadDocCategoryOptions.find((item) => item.key === selectedKey);
    return (match?.value && String(match.value).trim()) || selectedKey;
  }

  private resolveSelectedUploadType(): string | null {
    const selectedKey = String(this.uploadDocMetaForm.get('type')?.value ?? '').trim();
    if (!selectedKey) {
      return null;
    }
    const candidates = [...(this.uploadFilteredDocTypeOptions || [])];
    const match = candidates.find((item) => item.key === selectedKey);
    return (match?.value && String(match.value).trim()) || selectedKey;
  }

  clearFileInput(event: any): void {
    event.target.value = null;
  }

  onDropFile(event: DragEvent): void {
    event.preventDefault();
    this.dropzoneActive = false;
    if (event.dataTransfer?.files && event.dataTransfer.files.length > 0) {
      this.setUploadedFile(event.dataTransfer.files[0]);
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.dropzoneActive = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.dropzoneActive = false;
  }

  clearUploadFile(): void {
    this.uploadData = { file: null, fileName: '', type: '' };
    this.uploadError = null;
    this.saveEnable = true;
  }

  handleFileUpload(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {
      return;
    }
    this.setUploadedFile(input.files[0]);
  }

  private setUploadedFile(file: File): void {
    const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png'];
    const fileName = file.name.toLowerCase();
    const hasValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));
    if (!hasValidExtension) {
      this.uploadError = this.errorMessage['M0129'];
      this.uploadData = { file: null, fileName: '', type: '' };
      this.saveEnable = true;
      return;
    }
    const maxSize = 15 * 1024 * 1024;
    if (file.size > maxSize) {
      this.uploadError = this.errorMessage['M0128'];
      this.uploadData = { file: null, fileName: '', type: '' };
      this.saveEnable = true;
      return;
    }
    this.uploadData.file = file;
    this.uploadData.fileName = file.name;
    this.uploadData.type = file.type || '';
    this.uploadError = null;
    this.saveEnable = false;
  }

  private getCurrentUserId(): number | null {
    try {
      const userRaw = sessionStorage.getItem('user');
      if (!userRaw) return null;
      const user = JSON.parse(userRaw);
      const id = user?.user_id ?? user?.id ?? user?.userId ?? null;
      return id !== null ? Number(id) : null;
    } catch {
      return null;
    }
  }
  onSupportingDocumentsUpload(key: any): void {
    if (!this.personId) {
      this.alertService.warn('Person ID is required.');
      return;
    }
    this.selectedGridForUpload = key;
    this.staffDocNoticeModal.open({ contentVariant: 'default' }).then((confirmed) => {
      if (confirmed) {
        this.openUploadModalAfterNotice();
      }
    });
  }

  async onSaveUploadFile(): Promise<void> {
    if (!this.uploadData?.fileName) {
      this.uploadError = 'Please select a file.';
      return;
    }
    if (this.uploadDocMetaForm.invalid) {
      this.uploadDocMetaForm.markAllAsTouched();
      this.alertService.error(this.toastMessage['T0017'] || 'Please fill in all required fields.');
      return;
    }

    this.selectedUploadMeta = {
      fileName: this.uploadData.fileName || '',
      contentType: this.uploadData.type || ''
    };
    const formData = this.currentUploadSection === 'academic-Background'
      ? this.AcademicBGForm.value
      : this.currentUploadSection === 'employment_prof_dev' ? this.ProfDevEmploymentForm.value :
        this.currentUploadSection === 'Additional_prof_dev' ? this.addtionalProfDevForm.value
          : {};

    const meta = this.uploadDocMetaForm.getRawValue() as { category?: string; type?: string };
    const selectedCategoryKey = String(meta.category ?? '').trim();
    const selectedTypeKey = String(meta.type ?? '').trim();
    const selectedCat = this.uploadDocCategoryOptions.find((c) => c.key === selectedCategoryKey);
    const categoryDisplay = selectedCat?.value ?? this.resolveSelectedUploadCategory() ?? selectedCategoryKey;
    const typeOption = this.uploadFilteredDocTypeOptions.find((t) => t.key === selectedTypeKey);
    const typeDisplay = typeOption?.value ?? this.resolveSelectedUploadType() ?? selectedTypeKey;

    const file = this.uploadData.file as File;
    if (!(file instanceof File)) {
      this.alertService.error('Please select a file.');
      return;
    }
    const personIdNum = this.personId ? Number(this.personId) : 0;
    const categoryLookups = toDuplicateLookupOptions(this.docCategoryOptions);
    const typeLookups = toDuplicateLookupOptions(this.allDocTypeOptions);
    if (personIdNum && selectedCategoryKey) {
      const proceed = await this.duplicateDocGuard.ensureProceedOrCancel({
        educatorDashboardRow: this.educatorDashboardRow as Record<string, unknown> | null,
        categoryKey: selectedCategoryKey,
        typeKey: selectedTypeKey || undefined,
        fileName: file.name,
        screenName: 'Lookup User - Education',
        personId: personIdNum,
        categoryDisplay: categoryDisplay ? String(categoryDisplay) : undefined,
        typeDisplay: typeDisplay ? String(typeDisplay) : undefined,
        categoryLookups,
        typeLookups
      });
      if (!proceed) {
        this.uploadData = { file: null, fileName: '', type: '' };
        this.uploadError = '';
        this.selectedUploadMeta = { fileName: '', contentType: '' };
        return;
      }
    }

    const sectionTabLabelMap: Record<string, string> = {
      'academic-Background': 'Academic Background',
      'employment_prof_dev': 'District / Charter Employment',
      'Additional_prof_dev': 'Additional Professional Development',
      'programs-upload': 'Programs'
    };
    const profileTabSection = sectionTabLabelMap[this.currentUploadSection] ?? this.currentUploadSection;

    const uploadData = {
      person_id: this.personId ? Number(this.personId) : null,
      uploaded_by: this.getCurrentUserId(),
      uploaded_at: new Date().toISOString(),
      profile_tab_section: profileTabSection,
      file_name: this.selectedUploadMeta.fileName || '',
      cd_document_category: selectedCategoryKey,
      cd_document_type: selectedTypeKey,
      formid: LOOKUP_USER_SECTION_FORM_IDS[profileTabSection] ?? null,
      form_data: {
        ...formData,
        cd_document_category: selectedCategoryKey,
        cd_document_type: selectedTypeKey
      }
    };

    educatorDocumentUploadWithClientBlobPut(this.httpService, file, uploadData)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          const success = res?.status === 'success' || res?.data?.success === true;
          if (success) {
            appendProfileUploadToDashboardRow(
              this.educatorDashboardRow as Record<string, unknown> | null,
              buildProfileUploadRowForLocalCache({
                cd_document_category: selectedCategoryKey,
                cd_document_type: selectedTypeKey,
                document_category: categoryDisplay ? String(categoryDisplay) : undefined,
                document_type: typeDisplay ? String(typeDisplay) : undefined,
                file_name: file.name,
                profile_tab_section: profileTabSection
              })
            );
            this.alertService.success(this.toastMessage['T0005'] || 'Added successfully.');
            this.refreshEducatorsData();
            if (String(selectedCategoryKey).trim() === '10') {
              this.triggerAutoTranscriptUpdate();
            }
            this._actuallyCloseUploadPopup();
          } else {
            this.alertService.error(res?.data?.message || res?.message || 'Failed to upload document. Please try again.');
            this._actuallyCloseUploadPopup();
          }
        },
        error: (err: any) => {
          this.alertService.error(err?.error?.message || err?.message || 'Failed to upload document. Please try again.');
          this._actuallyCloseUploadPopup()
        }
      });
  }

  private mapEducationData(): void {
    const source = this.educatorDashboardRow as Record<string, unknown> | null;
    if (!source) {
      this.academicBgRows = [];
      this.profDevEmploymentRows = [];
      this.additionalProfDevRows = [];
      this.profile_documents = {};
      this._lastEducationSupportingDocRows = [];
      this.districtCharterRows = [];
      this.additionalSupportRows = [];
      return;
    }

    const toArrayOfObjects = (value: any): object[] => {
      if (Array.isArray(value)) return value;
      return [];
    };

    this.academicBgRows = (this.educatorDashboardRow?.['p_education'] || []).map((item: any) => ({
      ...item,
      updated_by: item['updated_by'] || '---',
      credit_earned: item['credit_earned'] != null ? parseFloat(item['credit_earned']).toFixed(2) : item['credit_earned']
    }));
    this.profDevEmploymentRows = (this.educatorDashboardRow?.['p_prof_dev_district_charter'] || []).map((item: any) => ({
      ...item,
      updated_by: item['updated_by'] || '---',
      district_charter_prof_dev_hrs_display: item['district_charter_prof_dev_hrs'] != null ? parseFloat(item['district_charter_prof_dev_hrs']).toFixed(2) + ' hours' : '---'
    }));
    this.additionalProfDevRows = (this.educatorDashboardRow?.['p_prof_dev_additional'] || []).map((item: any) => ({
      ...item,
      updated_by: item['updated_by'] || '---',
      additional_prof_dev_hrs_display: item['additional_prof_dev_hrs'] != null ? parseFloat(item['additional_prof_dev_hrs']).toFixed(2) + ' hours' : '---'
    }));
    const apps = Array.isArray(this.educatorDashboardRow?.['p_application'])
      ? this.educatorDashboardRow['p_application']
      : [];
    const rawUploadGrouped = _.groupBy(
      Array.isArray(this.educatorDashboardRow?.['p_profile_upload'])
        ? this.educatorDashboardRow['p_profile_upload']
        : [],
      'profile_tab_section'
    );
    const mapSection = (key: string) =>
      this.mapProfileUploadRowsForLookupGrid(rawUploadGrouped[key] ?? [], apps);
    this.profile_documents = {
      'Academic Background':                                              mapSection('Academic Background'),
      'District / Charter Employment':                                   mapSection('District / Charter Employment'),
      'Additional Professional Development':                             mapSection('Additional Professional Development'),
      'Programs':                                                        mapSection('Programs')
    };
    this.programsRows = (this.educatorDashboardRow?.['p_education_program'] || []).map((item: any) => ({
      ...item,
      program_notes: item.notes,
      updated_by: item['updated_by'] || '---'
    }));
    this.districtCharterRows = [...(this.profile_documents?.['District / Charter Employment'] ?? [])];
    this.additionalSupportRows = [...(this.profile_documents?.['Additional Professional Development'] ?? [])];
    this._lastEducationSupportingDocRows = [...Object.values(this.profile_documents).flat()];

    const filtered = this.educatorDashboardRow?.['p_education']
      ?.filter(item => item?.updated_date) ?? [];

    this.professionalBgRows = filtered.length
      ? filtered.reduce((prev, current) =>
        new Date(current.updated_date!) >
          new Date(prev.updated_date!)
          ? current
          : prev
      )
      : null;
    const profDevInfo = Array.isArray(this.educatorDashboardRow?.['p_prof_dev_info'])
      ? this.educatorDashboardRow['p_prof_dev_info'][0]
      : null;
    const professionalCourseDevHrs = profDevInfo?.prof_credits_earned ?? null;
    this.profDevCourseworkForm.get('sem_credits_earned').setValue(professionalCourseDevHrs ?? '');
    this.profDevCourseworkOriginalValue = String(professionalCourseDevHrs ?? '');

    this.preloadSupportingDocTypesForAcademicBackground()
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe(() => this.refreshAcademicBackgroundDocumentGrid());
  }

  private getProfileDocumentLabelContext(): ProfileDocumentLabelContext {
    return {
      categories: this.allSupportingDocCategories.length
        ? this.allSupportingDocCategories
        : this.uploadDocCategoryOptions,
      typesByCategory: this.supportingDocTypesCache,
      educationSectionCategoryOptions: this.educationSectionCategoryOptions
    };
  }

  private preloadSupportingDocTypesForAcademicBackground(): Observable<void> {
    const rawRows = Array.isArray(this.educatorDashboardRow?.['p_profile_upload'])
      ? (this.educatorDashboardRow['p_profile_upload'] as Record<string, unknown>[])
      : [];
    const academicRows = rawRows.filter((u) => {
      const s = String(u['profile_tab_section'] ?? '').trim();
      return s === 'Academic Background' || s === 'academic-Background';
    });
    const ctx = this.getProfileDocumentLabelContext();
    const missingKeys = uniqueSystemACategoryKeysFromDocuments(academicRows, ctx).filter(
      (key) => !this.supportingDocTypesCache[key]?.length
    );
    if (!missingKeys.length) {
      return of(void 0);
    }
    const categories = this.allSupportingDocCategories.length
      ? this.allSupportingDocCategories
      : this.uploadDocCategoryOptions;
    const requests = missingKeys.map((key) => {
      const cat = categories.find((c) => c.key === key);
      if (!cat) {
        return of([] as SupportingDocumentGridOption[]);
      }
      return this.supportingDocLookupService.getTypesByCategory(cat).pipe(
        tap((types) => {
          this.supportingDocTypesCache[key] = types;
        })
      );
    });
    return forkJoin(requests).pipe(map(() => void 0));
  }

  private refreshAcademicBackgroundDocumentGrid(): void {
    const apps = Array.isArray(this.educatorDashboardRow?.['p_application'])
      ? this.educatorDashboardRow['p_application']
      : [];
    const rawUploadGrouped = _.groupBy(
      Array.isArray(this.educatorDashboardRow?.['p_profile_upload'])
        ? this.educatorDashboardRow['p_profile_upload']
        : [],
      'profile_tab_section'
    );
    const academicMapped = this.mapProfileUploadRowsForLookupGrid(
      rawUploadGrouped['Academic Background'] ?? [],
      apps
    );
    if (this.profile_documents) {
      this.profile_documents['Academic Background'] = academicMapped;
    }
    this._lastEducationSupportingDocRows = [...Object.values(this.profile_documents || {}).flat()];
    this.updateDataGridConfig();
  }

  /**
   * Supporting-doc Application ID column: metadata must use `application_id` as `dataField` (or legacy
   * `application_number` mapped in the data grid) so `appIdTemplate` runs. Grids pass this handler as
   * `[onApplicationClick]` so `applyApplicationIdClickPolicy` keeps links enabled off-queue tabs. Row
   * mappers set `id` (internal) vs `application_id` (display) to match the template contract.
   */
  readonly onLookupApplicationIdClick = (applicationInternalId: string, event?: Event): void => {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    const idStr =
      applicationInternalId != null && String(applicationInternalId).trim() !== ''
        ? String(applicationInternalId).trim()
        : '';
    if (!idStr) {
      this.alertService.warn('No application is linked to this row.');
      return;
    }
    const gridRow =
      (this._lastEducationSupportingDocRows || []).find(r => String(r.id ?? '').trim() === idStr) ??
      (this.districtCharterRows || []).find(r => String(r.id ?? '').trim() === idStr) ??
      (this.additionalSupportRows || []).find(r => String(r.id ?? '').trim() === idStr);
    const selectedApp = this.buildSelectedAppForOpenFromLookup(idStr, gridRow);
    this.applicationOpenFromGrid.openApplicationLikeDataGrid(selectedApp, {
      returnTargets: lookupUserReturnTargets(this.personId),
      sourceTab: 'education',
      sourcePersonId: this.personId ?? undefined
    });
  };

  private findLookupValueByKey(list: Array<{ key: string; value: string }>, key: unknown): string {
    const k = String(key ?? '').trim();
    if (!k) {
      return '';
    }
    const hit = (list || []).find((item) => String(item?.key ?? '').trim() === k);
    return hit?.value ? String(hit.value).trim() : '';
  }

  private resolveProfileUploadCategoryDisplay(u: any, sectionOverride?: string): string {
    const section = String(sectionOverride ?? u?.profile_tab_section ?? '').trim();
    const directDisplay =
      u?.document_category ??
      u?.category_name ??
      u?.category ??
      u?.str_document_category ??
      u?.cd_document_category_name;
    const key =
      u?.cd_document_category ??
      u?.document_category ??
      u?.category ??
      u?.category_key ??
      '';
    if (section === 'Additional_prof_dev') {
      const providerName = this.findLookupValueByKey(this.profDevProvidersLookup || [], key);
      if (providerName) {
        return providerName;
      }
      const numericKey = Number(String(key ?? '').trim());
      if (Number.isFinite(numericKey) && numericKey > 0) {
        const idx = numericKey - 1;
        if ((this.profDevProvidersLookup || [])[idx]?.value) {
          return String(this.profDevProvidersLookup[idx].value).trim();
        }
      }
      return String(directDisplay ?? key ?? '').trim();
    }
    if (section === 'employment_prof_dev') {
      const districtName = this.findLookupValueByKey(this.districtsLookup || [], key);
      if (districtName) {
        return districtName;
      }
      const numericKey = Number(String(key ?? '').trim());
      if (Number.isFinite(numericKey) && numericKey > 0) {
        const idx = numericKey - 1;
        if ((this.districtsLookup || [])[idx]?.value) {
          return String(this.districtsLookup[idx].value).trim();
        }
      }
      return String(directDisplay ?? key ?? '').trim();
    }
    const docCategoryName = this.findLookupValueByKey(this.defaultDocCategoryOptions || this.docCategoryOptions || [], key);
    if (docCategoryName) {
      return docCategoryName;
    }
    return String(directDisplay ?? key ?? '').trim();
  }

  private resolveProfileUploadTypeDisplay(u: any): string {
    const directDisplay =
      u?.document_type ??
      u?.type ??
      u?.str_document_type ??
      u?.cd_document_type_name;
    const key =
      u?.cd_document_type ??
      u?.document_type ??
      u?.type ??
      u?.type_key ??
      '';
    const k = String(key ?? '').trim();
    if (k) {
      const fromLookup = (this.allDocTypeOptions || []).find((item) => String(item?.key ?? '').trim() === k);
      if (fromLookup?.value) {
        return String(fromLookup.value).trim();
      }
    }
    return String(directDisplay ?? key ?? '').trim();
  }

  /**
   * Normalize `p_profile_upload` rows: `id` = internal application id for grid click;
   * `application_id` = display id. Category/type labels resolved from docCategoryOptions / allDocTypeOptions.
   */
  private mapProfileUploadRowsForLookupGrid(rawRows: any[] | null | undefined, apps: any[]): any[] {
    if (!Array.isArray(rawRows) || rawRows.length === 0) {
      return [];
    }
    return rawRows.map((u: any) => {
      let internalId =
        u.application_id != null && String(u.application_id).trim() !== ''
          ? String(u.application_id).trim()
          : '';
      let matchedApp = internalId ? apps.find((a: any) => String(a.application_id) === internalId) : undefined;
      if (!matchedApp && internalId) {
        const byDisplay = apps.find(
          (a: any) => String(a.app_id ?? '').trim() !== '' && String(a.app_id).trim() === internalId
        );
        if (byDisplay) {
          matchedApp = byDisplay;
          internalId = String(byDisplay.application_id);
        }
      }
      const displayId =
        u.application_number != null && String(u.application_number).trim() !== ''
          ? String(u.application_number).trim()
          : matchedApp?.app_id != null && String(matchedApp.app_id).trim() !== ''
            ? String(matchedApp.app_id).trim()
            : internalId;
      const section = String(u.profile_tab_section ?? '').trim();
      const docRecord = { ...u, _raw: u } as Record<string, unknown>;
      const labelCtx = this.getProfileDocumentLabelContext();
      const document_category = resolveProfileDocumentCategoryLabel(docRecord, labelCtx);
      const document_type = resolveProfileDocumentTypeLabel(docRecord, labelCtx);
      return {
        ...u,
        document_category,
        document_type,
        id: internalId || displayId,
        application_id: displayId || '---',
        application_number: displayId,
        application_type: u.application_type ?? matchedApp?.app_type ?? '',
        application_status: u.application_status ?? matchedApp?.app_status ?? '',
        date_submitted: matchedApp?.date_submitted ?? u.date_submitted ?? ''
      };
    });
  }

  /**
   * `p_document` rows merged into education supporting grids lack `id`; the data grid passes `cell.data.id`
   * into onLookupApplicationIdClick. Align shape with profile uploads + Personal `p_document` mapping.
   */
  private mapEducationPdocumentRowsForLookupGrid(rawRows: any[] | null | undefined, apps: any[]): any[] {
    if (!Array.isArray(rawRows) || rawRows.length === 0) {
      return [];
    }
    return rawRows.map((d: any) => {
      const rawAppKey =
        d.application_id ?? d.applicationId ?? d.p_application_id ?? d.internal_application_id;
      let internalId =
        rawAppKey != null && String(rawAppKey).trim() !== '' ? String(rawAppKey).trim() : '';
      let matchedApp = internalId ? apps.find((a: any) => String(a.application_id) === internalId) : undefined;
      if (!matchedApp && internalId) {
        const byDisplay = apps.find(
          (a: any) => String(a.app_id ?? '').trim() !== '' && String(a.app_id).trim() === internalId
        );
        if (byDisplay) {
          matchedApp = byDisplay;
          internalId = String(byDisplay.application_id);
        }
      }
      const rawAppNum = d.application_number ?? d.applicationNumber ?? d.app_id;
      const displayId =
        rawAppNum != null && String(rawAppNum).trim() !== ''
          ? String(rawAppNum).trim()
          : matchedApp?.app_id != null && String(matchedApp.app_id).trim() !== ''
            ? String(matchedApp.app_id).trim()
            : internalId;
      const document_category =
        d.document_category ??
        d.category_name ??
        d.category ??
        d.str_document_category ??
        d.cd_document_category_name ??
        (d.cd_document_category != null && String(d.cd_document_category).trim() !== ''
          ? String(d.cd_document_category)
          : '');
      const document_type =
        d.document_type ??
        d.type ??
        d.str_document_type ??
        d.cd_document_type_name ??
        (d.cd_document_type != null && String(d.cd_document_type).trim() !== ''
          ? String(d.cd_document_type)
          : '');
      return {
        ...d,
        id: internalId,
        application_id: internalId ? (displayId || '---') : '---',
        application_number: displayId,
        document_category,
        document_type,
        file_name: d.file_name ?? '',
        uploaded_by: d.uploaded_by ?? d.uploadedBy ?? '',
        uploaded_date: d.uploaded_date ?? d.uploadedDate ?? '',
        status: d.status ?? d.document_status ?? '',
        application_type: d.application_type ?? matchedApp?.app_type ?? '',
        application_status: d.application_status ?? matchedApp?.app_status ?? '',
        date_submitted: matchedApp?.date_submitted ?? d.date_submitted ?? ''
      };
    });
  }

  private educatorDisplayNameForModal(): string {
    const prof = this.educatorDashboardRow?.p_profile;
    if (prof && typeof prof === 'object' && !Array.isArray(prof)) {
      const fn = String((prof as any).first_name ?? (prof as any).firstName ?? '').trim();
      const ln = String((prof as any).last_name ?? (prof as any).lastName ?? '').trim();
      const combined = `${fn} ${ln}`.trim();
      if (combined) {
        return combined;
      }
      const n = (prof as any).person_name;
      if (n && String(n).trim()) {
        return String(n).trim();
      }
    }
    if (Array.isArray(prof) && prof[0]?.person_name) {
      return String(prof[0].person_name).trim();
    }
    return '—';
  }

  private licenseNumberForOpenFromLookup(internalId: string, gridRow?: any): string | undefined {
    const fromGrid = gridRow?.license_number ?? gridRow?.licenseNumber;
    if (fromGrid != null) {
      const g = String(fromGrid).trim();
      if (g && g !== '---') {
        return g;
      }
    }
    const dtl = this.educatorDashboardRow?.p_license_dtls;
    if (!Array.isArray(dtl) || dtl.length === 0) {
      return undefined;
    }
    const idNum = Number(internalId);
    const byApp = dtl.find(
      (l: any) =>
        l?.license_number != null &&
        String(l.license_number).trim() !== '' &&
        l.application_id != null &&
        Number(l.application_id) === idNum
    );
    if (byApp?.license_number) {
      return String(byApp.license_number).trim();
    }
    const active = dtl.find(
      (l: any) => l?.is_active === true && l?.license_number != null && String(l.license_number).trim() !== ''
    );
    if (active?.license_number) {
      return String(active.license_number).trim();
    }
    const first = dtl.find((l: any) => l?.license_number != null && String(l.license_number).trim() !== '');
    return first?.license_number != null ? String(first.license_number).trim() : undefined;
  }

  private buildSelectedAppForOpenFromLookup(internalId: string, gridRow?: any): ApplicationOpenGridRow {
    const row = this.educatorDashboardRow;
    const apps = Array.isArray(row?.p_application) ? row.p_application : [];
    const appMatch = apps.find((a: any) => String(a.application_id) === String(internalId));

    const rawDisplay = gridRow?.application_id != null ? String(gridRow.application_id).trim() : '';
    const displayApp =
      rawDisplay !== '' && rawDisplay !== '---'
        ? rawDisplay
        : appMatch?.app_id != null && String(appMatch.app_id).trim() !== ''
          ? String(appMatch.app_id).trim()
          : String(internalId);

    const idNumeric = normalizeNumericApplicationId(internalId);
    const licenseRaw = this.licenseNumberForOpenFromLookup(internalId, gridRow);
    return {
      id: idNumeric !== null ? idNumeric : internalId,
      application_id: displayApp,
      application_number: gridRow?.application_number ?? displayApp,
      application_type: (gridRow?.application_type ?? appMatch?.app_type ?? '') as string,
      date_submitted: (gridRow?.date_submitted ?? appMatch?.date_submitted ?? '') as string,
      application_status: (gridRow?.application_status ?? appMatch?.app_status ?? '') as string,
      re_submitted_date: gridRow?.re_submitted_date as string | undefined,
      educator_name: this.educatorDisplayNameForModal(),
      is_archived: gridRow?.is_archived as boolean | undefined,
      ...(licenseRaw ? { license_number: licenseRaw } : {})
    };
  }

  private pickArray(source: Record<string, unknown>, keys: string[]): Record<string, unknown>[] {
    for (const key of keys) {
      const val = source[key];
      if (Array.isArray(val)) {
        return val as Record<string, unknown>[];
      }
    }
    return [];
  }

  private pickValue(source: Record<string, unknown>, keys: string[]): string {
    for (const key of keys) {
      const val = source[key];
      if (val !== null && val !== undefined && String(val).trim() !== '') {
        if (typeof val === 'number' && isNaN(val)) continue;
        const str = String(val).trim();
        if (str.toLowerCase() === 'nan') continue;
        return str;
      }
    }
    return '';
  }

  onColumnClick(text: string, key: any) {
    const allColsMap: Record<string, { key: string; disabled?: boolean }[]> = {
      visibleAllAcademicColumns: this.allAcadBgColumns,
      visibleAcademicSupportingColumns: this.academicSupportingColumns,
      visibleProfDevEmpColumns: this.allProfDevEmpColumns,
      visibleProfDevSupportColumns: this.academicSupportingColumns,
      visibleAdditonalDevColumns: this.allAdditionalDevColumns,
      visibleAdditionalSupportColumns: this.academicSupportingColumns,
      visibleProgramsColumns: this.allProgramsColumns,
      visibleProgramsSupportColumns: this.academicSupportingColumns,
    };
    const cols = allColsMap[text];
    if (cols?.find(c => c.key === key)?.disabled) return;
    const current = !!this[text][key];
    if (!this[text]) this[text] = {};
    this[text][key] = !current;
    this.updateDataGridConfig();
    this.cd.detectChanges();
  }

  private lockFirstColumn(cols: { key: string; label: string; disabled?: boolean }[]): void {
    if (cols.length) cols[0].disabled = true;
  }

  downloadExcel(allColumns: string, visibleColumns: string, key: string, grid: DataGridComponent) {
    const excelKeys = [
      { key: "AcademicBgExcel", data: "academicBgRows", fileName: 'Academic_Background' },
      { key: "ProfDevEmploymentExcel", data: "profDevEmploymentRows", fileName: 'Employment_Prof_dev' },
      { key: "AdditionalDevHrsExcel", data: "additionalProfDevRows", fileName: 'Additional_Prof_dev' },
      { key: "AcademicSupportExcel", data: "profile_documents?.academic-Background", fileName: 'Academic_Bg_Support' },
      { key: "EmploymentProfExcel", data: "profile_documents?.employment_prof_dev ", fileName: 'Employemnt_Dev_Support' },
      { key: "AdditonalSupportExcel", data: "profile_documents?.Additional_prof_dev", fileName: 'Additional_Dev_Support' },
      { key: "ProgramsExcel", data: "programsRows", fileName: 'Programs' },
      { key: "ProgramsSupportExcel", data: "profile_documents?.programs-upload", fileName: 'Programs_Support' },
    ];
    const exceltoDownload = excelKeys.find((item) => item.key === key)
    this.data = this[exceltoDownload.data];
    const visibleCols = this[allColumns].filter(col => this[visibleColumns][col.key]);
    if (visibleCols.length === 0) {
      window.alert('No columns selected for export');
      return;
    }
    const headers = grid?.config?.customHeaders || [];
    if (
      grid &&
      grid.dataGrid &&
      grid.dataGrid.instance &&
      typeof grid.exportFilteredDataToExcel === 'function'
    ) {
      const columns = visibleCols.map(col => {
        const header = headers.find((h: any) => h.dataField === col.key);
        return { label: col.label, key: col.key, dataType: header?.dataType };
      });
      const sheetName = exceltoDownload.fileName + ".xlsx";
      const gridInstance = grid.dataGrid.instance;
      const oldPageSize = gridInstance.pageSize ? gridInstance.pageSize() : null;
      const totalCount = gridInstance.totalCount ? gridInstance.totalCount() : null;
      if (oldPageSize && totalCount && oldPageSize < totalCount) {
        gridInstance.pageSize(totalCount);
        setTimeout(() => {
          grid.exportFilteredDataToExcel(columns, sheetName);
          setTimeout(() => {
            gridInstance.pageSize(oldPageSize);
          }, 500);
        }, 200);
        return;
      }
      grid.exportFilteredDataToExcel(columns, sheetName);
      return;
    }
    const rows = Array.isArray(this.data) ? this.data : [];
    if (rows.length === 0) {
      window.alert('No data to export');
      return;
    }
    const exportRows = rows.map(row => {
      const filtered: any = {};
      visibleCols.forEach(col => {
        filtered[col.key] = row[col.key];
      });
      return filtered;
    });
    const exportColumns = visibleCols.map(col => {
      const header = headers.find((h: any) => h.dataField === col.key);
      return { label: col.label, key: col.key, dataType: header?.dataType };
    });
    const sheetName = exceltoDownload.fileName + ".xlsx";
    this.commonService.exportToExcel(exportRows, exportColumns, sheetName);

  }

  /** Only rebuild grids when both metadata headers and category lookups are loaded — mirrors activities tab pattern. */
  private rebuildEducationGridsIfReady(): void {
    if (!this.metadataLoaded || !this.lookupsLoaded) {
      return;
    }
    this.refreshAcademicBackgroundDocumentGrid();
    this.mapEducationData();
    this.updateDataGridConfig();
  }

  updateDataGridConfig() {
    this.academicBgDataGrid = DataGridVO.create({
      customHeaders: this.academicBGHeaders,
      data: this.academicBgRows,
      visibleColumns: this.visibleAllAcademicColumns,
      showQueueActions: true,
      role: 'lookup-Academic-logs',
      activeTab: 'education',
      showPaging: true,

    });
    this.academicBgSupportGrid = DataGridVO.create({
      customHeaders: this.academicBGSupportingHeaders,
      data: this.profile_documents?.["Academic Background"] || [],
      visibleColumns: this.visibleAcademicSupportingColumns,
      showQueueActions: true,
      role: 'education',
      activeTab: 'education',
      showPaging: true,
      disableApplicationClick: false
    });
    this.profDevEmpDataGrid = DataGridVO.create({
      customHeaders: this.profDevEmpHeaders,
      data: this.profDevEmploymentRows,
      visibleColumns: this.visibleProfDevEmpColumns,
      showQueueActions: true,
      showPaging: true,
      role: 'education',
      activeTab: 'lookup-prof-dev-emp-logs',

    });
    this.profDevEmpSupportGrid = DataGridVO.create({
      customHeaders: this.academicBGSupportingHeaders,
      data: this.districtCharterRows || [],
      visibleColumns: this.visibleProfDevSupportColumns,
      showQueueActions: true,
      role: 'lookup-prof-dev-emp-logs',
      activeTab: 'education',
      disableApplicationClick: false
    });
    this.additionalProfDevGrid = DataGridVO.create({
      customHeaders: this.additionalProfDevHeaders,
      data: this.additionalProfDevRows,
      visibleColumns: this.visibleAdditonalDevColumns,
      showQueueActions: true,
      role: 'lookup-prof-dev-emp-logs',
      activeTab: 'education',
      disableApplicationClick: false,
      showPaging: true
    });
    this.additionalDevSupportGrid = DataGridVO.create({
      customHeaders: this.academicBGSupportingHeaders,
      data: this.additionalSupportRows || [],
      visibleColumns: this.visibleAdditionalSupportColumns,
      showQueueActions: true,
      role: 'lookup-prof-dev-emp-logs',
      activeTab: 'education',
      disableApplicationClick: false
    });
    this.programsGrid = DataGridVO.create({
      customHeaders: this.programsHeaders,
      data: this.programsRows || [],
      visibleColumns: this.visibleProgramsColumns,
      showQueueActions: true,
      role: 'lookup-prof-dev-emp-logs',
      activeTab: 'education',
      disableApplicationClick: false
    });
    this.programsSupportGrid = DataGridVO.create({
      customHeaders: this.academicBGSupportingHeaders,
      data: this.profile_documents?.["Programs"] || [],
      visibleColumns: this.visibleProgramsSupportColumns,
      showQueueActions: true,
      role: 'lookup-prof-dev-emp-logs',
      activeTab: 'education',
      disableApplicationClick: false
    });

  }
  resetProgramData() {
    const row = this.selectedProgramRow
    const rawDate = row?.separation_date;
    let separationDate = rawDate
    if (rawDate && !rawDate.includes('/')) {
      const m = String(rawDate).match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (m) separationDate = `${m[2]}/${m[3]}/${m[1]}`;
    }
    const previousValues = {
      separation_date: separationDate,
      notes: this.selectedProgramRow?.program_notes
    }
    this.programsForm.setValue(previousValues);
  }
  toggleProgramsSection(){
    this.showProgramSection= !this.showProgramSection
  }

  editProgramRow(row, template: TemplateRef<any>) {
    const Datecontrol = this.programsForm.get('separation_date');
    const noteControl = this.programsForm.get('notes');
    if(Datecontrol.disabled){
      Datecontrol.enable();
    } if(noteControl.disabled){
      noteControl.enable();
    }
    this.showButtons =true;
    let rawDate = row?.separation_date;
    let separationDate = rawDate
    if (rawDate && !rawDate.includes('/')) {
      const m = String(rawDate).match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (m) separationDate = `${m[2]}/${m[3]}/${m[1]}`;
    }
    const data = {
      separation_date: separationDate,
      notes: row.program_notes
    }
    this.selectedProgramRow = { ...row }
    this.programsForm.setValue(data);
    this.openDialog(template)
  }
  editAcademicBackgroundRow(row: any, template: TemplateRef<any>) {
    this.showAcademicBGForm = false;
    this.isEditAcademicBgModal = true;
    const institute_location = this.keyByValue(this.institutionLocationLookup, row?.institution_location);
    const cred_type = this.keyByValue(this.credentialTypeLookup, row?.credential_type);
    const degreeEarned = this.keyByValue(this.degreeEarnedLookup, row?.degree_earned);
    const fieldStudy = this.keyByValue(this.fieldOfStudyLookup, row?.cd_major_minor);
    const rawDate = row?.completion_date;
    let completionDate = rawDate
    if (rawDate && !rawDate.includes('/')) {
      const m = String(rawDate).match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (m) completionDate = `${m[2]}/${m[3]}/${m[1]}`;
    }
    const studentGradeLevel = this.keyByValue(this.studentTeachingGradeLookup, row?.student_grade_level) ||null;
    this.selectedAcademicBackground = { ...row };
    if (this.isEditAcademicBgModal) {
      this.AcademicBGForm.patchValue({
        institution_location: institute_location,
        credential_type: cred_type,
        degree_earned: degreeEarned,
        cd_major_minor: fieldStudy,
        institution_name: row?.institution_name,
        completion_date: completionDate,
        credit_earned: row?.credit_earned,
        field_of_study: row?.field_of_study,
        student_grade_level: studentGradeLevel,
        student_credits_earned: row?.student_credits_earned
      });
    }
    this.AcademicBGForm.markAsPristine();
    this.openDialog(template);
    this.dialogRef.afterClosed().pipe(take(1)).subscribe(() => {
      this.isEditAcademicBgModal = false;
      this.showAcademicBGForm = false;
    });
  }
  openDialog(template: TemplateRef<any>) {
    this.dialogRef = this.dialog.open(template, {
      width: '1140px',
      panelClass: 'custom-modalbox'
    });
  }
  editEmploymentDevRow(row: any, template: TemplateRef<any>) {
    this.isEditEmploymentDevForm = true;
    this.selectedEmploymentProf = { ...row };
    const districtCharterName = this.keyByValue(this.districtsLookup, row?.district_charter_name);
    if (this.isEditEmploymentDevForm) {
      this.ProfDevEmploymentForm.patchValue({
        district_charter_name: districtCharterName,
        district_charter_prof_dev_hrs: row?.district_charter_prof_dev_hrs
      })
    }
    this.openDialog(template)
  }

  editAdditionalDevForm(row: any, template: TemplateRef<any>) {
    this.isEditAdditionalDevForm = true;
    this.selectedAdditionalProf = { ...row }
    const providerName = this.keyByValue(this.profDevProvidersLookup, row?.provider_name);
    if (this.isEditAdditionalDevForm) {
      this.addtionalProfDevForm.patchValue({
        provider_name: providerName,
        additional_prof_dev_hrs: row?.additional_prof_dev_hrs
      })
    }
    this.openDialog(template);
  }

  private keyByValue(list: { key: string; value: string }[], display: string): string {
    if (!display) return '';
    const found = list.find(l => l.value === display || l.key === display);
    return found ? found.key : display;
  }

  private normalizeStr(val: unknown): string {
    if (val === null || val === undefined) return '';
    return String(val).toLowerCase().trim().replace(/\s+/g, ' ');
  }

  private isProfDevEmploymentDuplicate(): boolean {
    const fv = this.ProfDevEmploymentForm.value;
    return this.profDevEmploymentRows.some((row: any) =>
      this.normalizeStr(this.keyByValue(this.districtsLookup, row['district_charter_name'])) === this.normalizeStr(fv.district_charter_name) &&
      String(row['district_charter_prof_dev_hrs']) === String(fv.district_charter_prof_dev_hrs)
    );
  }

  private isAdditionalProfDevDuplicate(): boolean {
    const fv = this.addtionalProfDevForm.value;
    return this.additionalProfDevRows.some((row: any) =>
      this.normalizeStr(this.keyByValue(this.profDevProvidersLookup, row['provider_name'])) === this.normalizeStr(fv.provider_name) &&
      String(row['additional_prof_dev_hrs']) === String(fv.additional_prof_dev_hrs)
    );
  }

  private isAcademicBgDuplicate(): boolean {
    const fv = this.AcademicBGForm.value;
    const normDate = (d: any) => {
      const s = String(d ?? '').trim();
      if (!s) return '';
      if (!s.includes('/')) {
        const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (m) return `${m[2]}/${m[3]}/${m[1]}`;
      }
      return s;
    };
    return this.academicBgRows.some((row: any) =>
      this.normalizeStr(row['institution_name']) === this.normalizeStr(fv.institution_name) &&
      this.normalizeStr(this.keyByValue(this.institutionLocationLookup, row['institution_location'])) === this.normalizeStr(fv.institution_location) &&
      this.normalizeStr(this.keyByValue(this.credentialTypeLookup, row['credential_type'])) === this.normalizeStr(fv.credential_type) &&
      this.normalizeStr(this.keyByValue(this.degreeEarnedLookup, row['degree_earned'])) === this.normalizeStr(fv.degree_earned) &&
      this.normalizeStr(this.keyByValue(this.fieldOfStudyLookup, row['cd_major_minor'])) === this.normalizeStr(fv.cd_major_minor) &&
      normDate(row['completion_date']) === normDate(fv.completion_date)
    );
  }
  saveProfDevEmployment() {
     if(this.ProfDevEmploymentForm.invalid){
      this.ProfDevEmploymentForm.markAllAsTouched();
      this.alertService.error(this.toastMessage['T0017'] || 'Please fill in all required fields.');
       return;
    }

    if (this.isProfDevEmploymentDuplicate()) {
      this.alertService.error('Duplicate entry detected. This record already exists.');
      return;
    }
    const data = {
      ...this.ProfDevEmploymentForm.value,
      updatedBy: this.getCurrentUserId(),
      updatedDate: new Date().toISOString(),
      personId: this.personId

    }
    this.httpService.post(API_ENDPOINTS.USER_EDUCATOR_TAB.Insert_EMP_DEV_HOURS, data).subscribe({
      next: (res: any) => {
        const success = res?.status === 'success' || res?.data?.success === true;
        if (success) {
          this.showProfDevEmpForm = false;
          this.refreshEducatorsData();
          this.resetEmpProfDevForm();
          this.alertService.success(this.toastMessage['T0005']|| 'Added successfully.');
        } else {
          this.alertService.error(res?.data?.message || res?.message || 'Failed to save, Please try after sometime!');
        }
      }
      , error: (err: any) => {
        this.showProfDevEmpForm = false;
        this.resetEmpProfDevForm();
        this.alertService.error(err?.error?.message || err?.message || 'Failed to save, Please try after sometime!');
      }
    })
  }
  // reset forms
  resetEmpProfDevForm() {
    this.ProfDevEmploymentForm.reset();
  }
  resetProfDevHrs() {
    const profDevInfo = Array.isArray(this.educatorDashboardRow?.['p_prof_dev_info'])
      ? this.educatorDashboardRow['p_prof_dev_info'][0]
      : null;
    const previousValue = profDevInfo?.prof_credits_earned ?? null;
    this.profDevCourseworkForm.get('sem_credits_earned')?.setValue(previousValue ?? '');
    this.profDevCourseworkOriginalValue = String(previousValue ?? '');
  }
  resetAdditionalDevForm() {
    this.addtionalProfDevForm.reset();
  }
  resetAcademicBgForm() {
    this.AcademicBGForm.reset();
  }

  // refresh data
  // ── Transcript Status ──

  shouldShowTranscriptAction(row: any): boolean {
    const roleId = this.user?.role_id ?? this.user?.roleId;
    if (String(roleId) === '405') return false;
    const credTypeText = String(row?.credential_type ?? '').trim().toLowerCase();
    if (credTypeText === 'high school diploma or equivalent') return false;
    const status = String(row?.transcript_status ?? '').trim().toLowerCase();
    return status === 'pending';
  }

  onMarkTranscriptReceived(row: any, template: TemplateRef<any>): void {
    this.transcriptRowData = row;

    const institutionName = row?.institution_name || '';
    const major = row?.cd_major_minor || '';
    const cdDegreeEarned = row?.cd_degree_earned;
    const degreeEarnedValue = row?.degree_earned;

    if (cdDegreeEarned === 0 || cdDegreeEarned === '0' || (degreeEarnedValue && degreeEarnedValue.toLowerCase() === 'yes')) {
      const completionDate = row?.completion_date ? new Date(row.completion_date).toLocaleDateString('en-US') : '';
      const message = `By clicking Confirm, you are indicating that the transcript for <b>${institutionName}, ${major},</b> with a Degree Completion Date of <b>${completionDate}</b>, has been received and uploaded.`;
      this.transcriptMessage = this.sanitized.bypassSecurityTrustHtml(message);
    } else {
      const creditsEarned = row?.credit_earned || '';
      const message = `By clicking Confirm, you are indicating that the transcript for <b>${institutionName}, ${major},</b> with <b>${creditsEarned}</b> credits earned, has been received and uploaded.`;
      this.transcriptMessage = this.sanitized.bypassSecurityTrustHtml(message);
    }

    this.transcriptModalRef = this.modalService.open(template, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      windowClass: 'add-appointment-details'
    });
  }

  onConfirmTranscript(): void {
    if (!this.transcriptRowData) return;
    const educationId = this.transcriptRowData?.profile_education_id
      ?? this.transcriptRowData?.id
      ?? this.transcriptRowData?.education_id;
    if (!educationId) {
      this.alertService.error('Unable to identify the record to update.');
      return;
    }
    const payload = {
      profile_education_id: educationId,
      transcript_status: 'Received',
      transcript_received_date: new Date().toISOString()
    };
    this.httpService.post(API_ENDPOINTS.USER_EDUCATOR_TAB.Update_Transcript_Status, payload)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          const success = res?.status === 'success' || res?.data?.success === true || res?.success === true;
          if (success) {
            this.alertService.success('Status updated successfully');
            this.transcriptModalRef?.close();
            this.transcriptModalRef = null;
            this.transcriptRowData = null;
            this.refreshEducatorsData();
          } else {
            this.alertService.error(res?.data?.message || res?.message || 'Failed to update transcript status.');
          }
        },
        error: (err: any) => {
          this.alertService.error(err?.error?.message || err?.message || 'Failed to update transcript status.');
        }
      });
  }

  getTranscriptStatusClass(status: string): string {
    switch (String(status ?? '').trim().toLowerCase()) {
      case 'pending': return 'status-pending';
      case 'received': return 'status-validated';
      default: return 'status-default';
    }
  }

  ngOnDestroy(): void {
    window.removeEventListener('supporting-document-uploaded', this.onDocumentUploaded);
    this.destroy$.next();
    this.destroy$.complete();
  }

  private triggerAutoTranscriptUpdate(): void {
    if (!this.personId) return;
    this.httpService
      .post(API_ENDPOINTS.EDUCATOR_DASHBOARD_DATA, { personId: Number(this.personId) })
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          const row = response?.data?.data?.[0];
          if (!row) return;
          const educationRows: any[] = row?.['p_education'] || [];
          const eligibleItems = educationRows.filter(item => {
            const ctText = String(item.credential_type ?? '').trim().toLowerCase();
            return ctText === 'high school diploma or equivalent' &&
              String(item.transcript_status ?? '').trim().toLowerCase() !== 'received';
          });
          for (const item of eligibleItems) {
            const educationId = item.profile_education_id ?? item.id ?? item.education_id;
            if (educationId && !this.pendingTranscriptUpdates.has(educationId)) {
              this.pendingTranscriptUpdates.add(educationId);
              this.autoUpdateAcademicTranscriptStatus(educationId);
            }
          }
        },
        error: () => {}
      });
  }

  private autoUpdateAcademicTranscriptStatus(educationId: any): void {
    const payload = {
      profile_education_id: educationId,
      transcript_status: 'Received',
      transcript_received_date: new Date().toISOString()
    };
    this.httpService.post(API_ENDPOINTS.USER_EDUCATOR_TAB.Update_Transcript_Status, payload)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.pendingTranscriptUpdates.delete(educationId);
          this.refreshEducatorsData();
        },
        error: () => {
          this.pendingTranscriptUpdates.delete(educationId);
        }
      });
  }

  private refreshEducatorsData(): void {
    if (!this.personId) return;
    this.httpService
      .post(API_ENDPOINTS.EDUCATOR_DASHBOARD_DATA, { personId: Number(this.personId) })
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          const row = response?.data?.data?.[0];
          if (row) {
            this.educatorDashboardRow = row;
            this.mapEducationData()
            this.updateDataGridConfig();
            this.refreshed.emit({
                section: 'education',
                refreshedData: row
              });
          }
        },
        error: () => {
          // silently fail — data already visible from previous load
        }
      });
  }
  // close column chooser
  closeColumnChooser(text: string) {
    this[text] = false;
  }
  openDatePicker(flag: boolean, event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    const date_Input = !flag ? document.getElementById('date'): document.getElementById('separationDate')
    if (!date_Input) return;
    const rect = date_Input.getBoundingClientRect();
    const dateInput = document.createElement('input') as HTMLInputElement;
    dateInput.type = 'date';
    dateInput.style.position = 'absolute';
    dateInput.style.top = rect.top + window.scrollY + 5 + 'px';
    dateInput.style.left = rect.left + 'px';
    dateInput.style.width = '120px';
    dateInput.style.height = '35px';
    dateInput.style.opacity = '0.01';
    dateInput.style.border = 'none';
    dateInput.style.zIndex = '9999';
    dateInput.style.pointerEvents = 'auto';

    if (!flag) {
      // ✅ Past dates only
      dateInput.max = this.currentDate; // yyyy-mm-dd
    } else {
      // ✅ Any date (remove restriction)
      dateInput.removeAttribute('max');
      dateInput.removeAttribute('min');
    }

    // ✅ Pre-fill existing value
    const currentValue = flag
      ? this.programsForm.get('separation_date')?.value
      : this.AcademicBGForm.get('completion_date')?.value;

    if (currentValue && currentValue.includes('/')) {
      const parts = currentValue.split('/');
      if (parts.length === 3 && parts[2].length === 4) {
        const month = parts[0].padStart(2, '0');
        const day = parts[1].padStart(2, '0');
        const year = parts[2];
        dateInput.value = `${year}-${month}-${day}`;
      }
    }
    document.body.appendChild(dateInput);
    const cleanup = () => {
      if (document.body.contains(dateInput)) {
        dateInput.removeEventListener('change', changeHandler);
        dateInput.removeEventListener('blur', blurHandler);
        document.body.removeChild(dateInput);
      }
    };
    const changeHandler = (changeEvent: Event) => {
      const target = (changeEvent.target as HTMLInputElement);
      const selectedDate = target?.value;
      if (selectedDate) {
        const dateParts = selectedDate.split('-');
        if (dateParts.length === 3) {
          const formattedDate = `${dateParts[1]}/${dateParts[2]}/${dateParts[0]}`;
          if (!flag) {
            this.AcademicBGForm.get('completion_date')?.setValue(formattedDate);
            this.AcademicBGForm.get('completion_date')?.markAsTouched();
            this.AcademicBGForm.get('completion_date')?.updateValueAndValidity();
          } else {
            this.programsForm.get('separation_date')?.setValue(formattedDate);
            this.programsForm.get('separation_date')?.markAsTouched();
            this.programsForm.get('separation_date')?.updateValueAndValidity();
          }

        }
      }
      cleanup();
    };
    const blurHandler = () => setTimeout(cleanup, 100);
    dateInput.addEventListener('change', changeHandler);
    dateInput.addEventListener('blur', blurHandler);
    dateInput.focus();
    const inputEl = dateInput as HTMLInputElement;
    if (typeof (inputEl as any).showPicker === 'function') {
      try {
        (inputEl as any).showPicker();
      } catch {
        inputEl.click();
      }
    } else {
      inputEl.click();
    }
  }

  showAcademicBackground() {
    this.showAcademicBackgroundSection = !this.showAcademicBackgroundSection;
  }

  toggleForm() {
    this.isEditAcademicBgModal = false;
    this.resetAcademicBgForm();
    this.showAcademicBGForm = !this.showAcademicBGForm;
  }
  toggleDistictEmpForm() {
    this.showProfDevEmpForm = !this.showProfDevEmpForm
  }
  toggleAdditionalForm() {
    this.showAdditionalProfDevForm = !this.showAdditionalProfDevForm
  }
  toggleAdditionalProfDevSection() {
    this.showAdditionalProfDevSection = !this.showAdditionalProfDevSection
  }
  // cancel buttons for forms
  cancelProfDevadditionalForm() {
    this.showAdditionalProfDevForm = false;
    this.resetAdditionalDevForm();
  }
  cancelAcademicBGForm(): void {
    this.showAcademicBGForm = false;
    this.resetAcademicBgForm();
  }

  private filterInstitutionLocations(): void {
    const search = (this.institutionLocationFilterCtrl.value || '').toLowerCase().trim();
    if (!search) {
      this.filteredInstitutionLocations = [...this.institutionLocationLookup];
    } else {
      this.filteredInstitutionLocations = this.institutionLocationLookup.filter(s => s.value.toLowerCase().includes(search));
    }
  }

  onInstitutionLocationSelectOpened(opened: boolean): void {
    if (opened) {
      this.institutionLocationFilterCtrl.setValue('');
      this.filteredInstitutionLocations = [...this.institutionLocationLookup];
    }
  }

  private filterDegreeEarned(): void {
    const search = (this.degreeEarnedFilterCtrl.value || '').toLowerCase().trim();
    if (!search) {
      this.filteredDegreeEarned = [...this.degreeEarnedLookup];
    } else {
      this.filteredDegreeEarned = this.degreeEarnedLookup.filter(s => s.value.toLowerCase().includes(search));
    }
  }

  onDegreeEarnedSelectOpened(opened: boolean): void {
    if (opened) {
      this.degreeEarnedFilterCtrl.setValue('');
      this.filteredDegreeEarned = [...this.degreeEarnedLookup];
    }
  }

  private filterCredentialType(): void {
    const search = (this.credentialTypeFilterCtrl.value || '').toLowerCase().trim();
    if (!search) {
      this.filteredCredentialType = [...this.credentialTypeLookup];
    } else {
      this.filteredCredentialType = this.credentialTypeLookup.filter(s => s.value.toLowerCase().includes(search));
    }
  }

  onCredentialTypeSelectOpened(opened: boolean): void {
    if (opened) {
      this.credentialTypeFilterCtrl.setValue('');
      this.filteredCredentialType = [...this.credentialTypeLookup];
    }
  }

  private filterDistricts(): void {
    const search = (this.districtsFilterCtrl.value || '').toLowerCase().trim();
    if (!search) {
      this.filteredDistrictsLookup = [...this.districtsLookup];
    } else {
      this.filteredDistrictsLookup = this.districtsLookup.filter(s => s.value.toLowerCase().includes(search));
    }
  }

  onDistrictsSelectOpened(opened: boolean): void {
    if (opened) {
      this.districtsFilterCtrl.setValue('');
      this.filteredDistrictsLookup = [...this.districtsLookup];
    }
  }

  private filterProfDevProviders(): void {
    const search = (this.providersFilterCtrl.value || '').toLowerCase().trim();
    if (!search) {
      this.filteredProfDevProviders = [...this.profDevProvidersLookup];
    } else {
      this.filteredProfDevProviders = this.profDevProvidersLookup.filter(s => s.value.toLowerCase().includes(search));
    }
  }

  onProvidersSelectOpened(opened: boolean): void {
    if (opened) {
      this.providersFilterCtrl.setValue('');
      this.filteredProfDevProviders = [...this.profDevProvidersLookup];
    }
  }

  private filterStudentTeachingGrades(): void {
    const search = (this.studentTeachingGradeFilterCtrl.value || '').toLowerCase().trim();
    if (!search) {
      this.filteredStudentTeachingGrades = [...this.studentTeachingGradeLookup];
    } else {
      this.filteredStudentTeachingGrades = this.studentTeachingGradeLookup.filter(s => s.value.toLowerCase().includes(search));
    }
  }

  onStudentTeachingGradeSelectOpened(opened: boolean): void {
    if (opened) {
      this.studentTeachingGradeFilterCtrl.setValue('');
      this.filteredStudentTeachingGrades = [...this.studentTeachingGradeLookup];
    }
  }

  cancelProfDevEmploymentForm(): void {
    this.showProfDevEmpForm = false;
    this.resetEmpProfDevForm()
  }
  // close and reset edit Modals
  closeAdditionaDevModal() {
    this.showAdditionalProfDevForm = false;
    this.dialogRef.close();
    this.addtionalProfDevForm.reset();
    this.isEditAdditionalDevForm = false;
  }
  closeProgramsModal() {
    this.dialogRef.close()
  }
  resetProfDevAdditionalHrs() {
    const providerName= this.keyByValue(this.profDevProvidersLookup, this.selectedAdditionalProf.provider_name )
    const previousValues = {
      provider_name: providerName,
      additional_prof_dev_hrs: this.selectedAdditionalProf.additional_prof_dev_hrs
    }
    this.addtionalProfDevForm.setValue(previousValues);
  }
  closeEmpDevModal() {
    this.showProfDevEmpForm = false;
    this.dialogRef.close();
    this.profDevCourseworkForm.reset();
    this.isEditEmploymentDevForm = false;
  }
  resetProfDevEmployment() {
    const districtCharterName = this.keyByValue(this.districtsLookup,this.selectedEmploymentProf.district_charter_name)
    const previousValues = {
      district_charter_name: districtCharterName,
      district_charter_prof_dev_hrs: this.selectedEmploymentProf.district_charter_prof_dev_hrs
    }
    this.ProfDevEmploymentForm.setValue(previousValues);
  }
  closeAcademicEditModal() {
    this.showAcademicBGForm = false;
    this.dialogRef.close();
    this.AcademicBGForm.reset();
    this.isEditAcademicBgModal = false;
  }
  resetAcademicDevValues() {
    const row = this.selectedAcademicBackground
    const rawDate = row?.completion_date;
    let completionDate = rawDate
    if (rawDate && !rawDate.includes('/')) {
      const m = String(rawDate).match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (m) completionDate = `${m[2]}/${m[3]}/${m[1]}`;
    }
    const studentGradeLevel = this.keyByValue(this.studentTeachingGradeLookup, this.selectedAcademicBackground?.student_grade_level)|| null;
    const previousValues = {
      institution_name: this.selectedAcademicBackground.institution_name,
      institution_location: this.keyByValue(this.institutionLocationLookup, row.institution_location),
      credential_type: this.keyByValue(this.credentialTypeLookup, row.credential_type),
      degree_earned: this.keyByValue(this.degreeEarnedLookup, row.degree_earned),
      completion_date: completionDate,
      credit_earned: this.selectedAcademicBackground.credit_earned,
      cd_major_minor: this.keyByValue(this.fieldOfStudyLookup, row.cd_major_minor),
      field_of_study: this.selectedAcademicBackground.field_of_study,
      student_credits_earned: this.selectedAcademicBackground?.student_credits_earned || null,
      student_grade_level: studentGradeLevel || null
    }
    this.AcademicBGForm.setValue(previousValues);
  }
  // format Date for completion date
  formatDateInput(event: Event, flag: boolean): void {
    const target = (event.target as HTMLInputElement);
    const value = (target?.value || '').replace(/\D/g, '');
    const limited = value.length > 8 ? value.substring(0, 8) : value;
    let formatted = limited;
    if (limited.length >= 5) formatted = `${limited.substring(0, 2)}/${limited.substring(2, 4)}/${limited.substring(4, 8)}`;
    else if (limited.length >= 3) formatted = `${limited.substring(0, 2)}/${limited.substring(2, 4)}`;
    else if (limited.length >= 1) formatted = limited.substring(0, 2);
    if (!flag) {
      this.AcademicBGForm.get('completion_date')?.setValue(formatted, { emitEvent: false });
    } else {
      this.programsForm.get('separation_date')?.setValue(formatted, { emitEvent: false });
    }
  }
  // edit for each Row
  updateAcademicBackGround() {
    if(this.AcademicBGForm.invalid){
      this.AcademicBGForm.markAllAsTouched();
      this.alertService.error(this.toastMessage['T0017'] || 'Please fill in all required fields.');
       return;
    }
    const educationId = this.selectedAcademicBackground?.profile_education_id
      ?? this.selectedAcademicBackground?.id
      ?? this.selectedAcademicBackground?.education_id
      ?? this.selectedAcademicBackground?.p_education_id;
    if (!educationId) {
      this.alertService.error('Unable to identify the record to update.');
      return;
    }
    const fvAcad = this.AcademicBGForm.getRawValue();
    const normDate = (d: any) => {
      const s = String(d ?? '').trim();
      if (!s) return '';
      if (!s.includes('/')) {
        const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (m) return `${m[2]}/${m[3]}/${m[1]}`;
      }
      return s;
    };
    const isDuplicateAcad = this.academicBgRows.some((row: any) => {
      const rowId = row['profile_education_id'] ?? row['id'] ?? row['education_id'] ?? row['p_education_id'];
      return String(rowId) !== String(educationId) &&
        this.normalizeStr(row['institution_name']) === this.normalizeStr(fvAcad.institution_name) &&
        this.normalizeStr(this.keyByValue(this.institutionLocationLookup, row['institution_location'])) === this.normalizeStr(fvAcad.institution_location) &&
        this.normalizeStr(this.keyByValue(this.credentialTypeLookup, row['credential_type'])) === this.normalizeStr(fvAcad.credential_type) &&
        this.normalizeStr(this.keyByValue(this.degreeEarnedLookup, row['degree_earned'])) === this.normalizeStr(fvAcad.degree_earned) &&
        this.normalizeStr(this.keyByValue(this.fieldOfStudyLookup, row['cd_major_minor'])) === this.normalizeStr(fvAcad.cd_major_minor) &&
        normDate(row['completion_date']) === normDate(fvAcad.completion_date);
    });
    if (isDuplicateAcad) {
      this.alertService.error('Duplicate entry detected. This record already exists.');
      return;
    }
    const rawValue = this.AcademicBGForm.getRawValue();
    const data = {
      ...rawValue,
      credit_earned: rawValue.credit_earned != null ? parseFloat(rawValue.credit_earned).toFixed(2) : rawValue.credit_earned,
      personId: this.personId,
      profile_education_id: educationId,
      updated_by: this.getCurrentUserId()
    }
    this.httpService.post(API_ENDPOINTS.USER_EDUCATOR_TAB.Update_AcademicBackground, data).subscribe({
      next: (res: any) => {
        const success = res?.status === 'success' || res?.data?.success === true;
        if (success) {
          this.refreshEducatorsData();
          this.isEditAcademicBgModal = false;
          this.showAcademicBGForm = false;
          this.resetAcademicBgForm();
          this.dialogRef.close();
          this.alertService.success(this.toastMessage['T0020'] || 'Updated successfully.');
        } else {
          this.alertService.error(res?.data?.message || res?.message || 'Failed to update, Please try after sometime!');
          this.isEditAcademicBgModal = false;
          this.dialogRef.close();
        }
      },
      error: (err: any) => {
        this.alertService.error(err?.error?.message || err?.message || 'Failed to update, Please try after sometime!');
        this.isEditAcademicBgModal = false;
        this.dialogRef.close();
      }
    })
  }

  updateProfDevEmployment() {
    if(this.ProfDevEmploymentForm.invalid){
      this.ProfDevEmploymentForm.markAllAsTouched();
      this.alertService.error(this.toastMessage['T0017'] || 'Please fill in all required fields.');
       return;
    }
    const empId = this.selectedEmploymentProf?.profile_prof_dev_district_charter_id;
    const fvEmp = this.ProfDevEmploymentForm.value;
    const isDuplicateEmp = this.profDevEmploymentRows.some((row: any) =>
      String(row['profile_prof_dev_district_charter_id']) !== String(empId) &&
      this.normalizeStr(this.keyByValue(this.districtsLookup, row['district_charter_name'])) === this.normalizeStr(fvEmp.district_charter_name) &&
      String(row['district_charter_prof_dev_hrs']) === String(fvEmp.district_charter_prof_dev_hrs)
    );
    if (isDuplicateEmp) {
      this.alertService.error('Duplicate entry detected. This record already exists.');
      return;
    }
    const data = {
      ...this.ProfDevEmploymentForm.value,
      personId: this.personId,
      profile_prof_dev_district_charter_id: this.selectedEmploymentProf.profile_prof_dev_district_charter_id
    }
    this.httpService.post(API_ENDPOINTS.USER_EDUCATOR_TAB.Update_Employment_DevHrs, data).subscribe({
      next: (res: any) => {
        const success = res?.status === 'success' || res?.data?.success === true;
        if (success) {
          this.refreshEducatorsData();
          this.isEditEmploymentDevForm= false;
          this.dialogRef.close()
          this.resetEmpProfDevForm();
          this.alertService.success(this.toastMessage['T0020'] || 'Updated successfully.');
        } else {
          this.alertService.error(res?.data?.message || res?.message || 'Failed to update, Please try after sometime!');
          this.isEditEmploymentDevForm= false;
          this.dialogRef.close();
        }
      },
      error: (err: any) => {
        this.alertService.error(err?.error?.message || err?.message || 'Failed to update, Please try after sometime!');
        this.isEditEmploymentDevForm= false;
        this.dialogRef.close();
      }
    })
  }

  updateProfDevAdditionalHrs() {
    if(this.addtionalProfDevForm.invalid){
      this.addtionalProfDevForm.markAllAsTouched();
      this.alertService.error(this.toastMessage['T0017'] || 'Please fill in all required fields.');
      return;
    }
    const addlId = this.selectedAdditionalProf?.profile_prof_dev_additional_id;
    const fvAddl = this.addtionalProfDevForm.value;
    const isDuplicateAddl = this.additionalProfDevRows.some((row: any) =>
      String(row['profile_prof_dev_additional_id']) !== String(addlId) &&
      this.normalizeStr(this.keyByValue(this.profDevProvidersLookup, row['provider_name'])) === this.normalizeStr(fvAddl.provider_name) &&
      String(row['additional_prof_dev_hrs']) === String(fvAddl.additional_prof_dev_hrs)
    );
    if (isDuplicateAddl) {
      this.alertService.error('Duplicate entry detected. This record already exists.');
      return;
    }
    const data = {
      ...this.addtionalProfDevForm.value,
      profile_prof_dev_additional_id: this.selectedAdditionalProf.profile_prof_dev_additional_id
    }
    this.httpService.post(API_ENDPOINTS.USER_EDUCATOR_TAB.Update_Additional_DevHrs, data).subscribe({
      next: (res: any) => {
        const success = res?.status === 'success' || res?.data?.success === true;
        if (success) {
          this.refreshEducatorsData();
          this.isEditAdditionalDevForm = false;
          this.dialogRef.close();
          this.resetAdditionalDevForm();
          this.alertService.success(this.toastMessage['T0020'] || 'Updated successfully.');
        } else {
          this.alertService.error(res?.data?.message || res?.message || 'Failed to update, Please try after sometime!');
          this.dialogRef.close();
          this.isEditAdditionalDevForm = false;
        }
      },
      error: (err: any) => {
        this.dialogRef.close();
        this.isEditAdditionalDevForm = false;
        this.alertService.error(err?.error?.message || err?.message || 'Failed to update, Please try after sometime!');
      }
    })

  }
  updateProgramData() {
    const data = {
      ...this.programsForm.value,
      education_program_id: this.selectedProgramRow?.education_program_id
    }
    this.httpService.post(API_ENDPOINTS.USER_EDUCATOR_TAB.Update_Program_Data, data).subscribe({
      next: (res: any) => {
        const success = res?.status === 'success' || res?.data?.success === true;
        if (success) {
          this.refreshEducatorsData();
          this.dialogRef.close();
          this.programsForm.reset();
          this.alertService.success(this.toastMessage['T0020'] || 'Updated successfully.');
        } else {
          this.alertService.error(res?.data?.message || res?.message || 'Failed to update, Please try after sometime!');
          this.dialogRef.close();
        }
      },
      error: (err: any) => {
        this.dialogRef.close();
        this.alertService.error(err?.error?.message || err?.message || 'Failed to update, Please try after sometime!');
      }
    })
  }
  viewNote(row: any, template: TemplateRef<any>) {
    const data= {
      separation_date: row?.separation_date,
      notes: row?.program_notes
    }
    this.programsForm.setValue(data);
    this.programsForm.get('separation_date').disable();
    this.programsForm.get('notes').disable();
    this.showButtons = false;
    this.openDialog(template);
  }


  // delete for each table rows
  openDeleteModal(row:any, key:any) {
    const gridId = (key === 'AcademicBackground') ? row?.profile_education_id : (key === 'EmploymentDevHrs') ?
      row?.profile_prof_dev_district_charter_id : (key === 'AdditionalDevHrs') ? row?.profile_prof_dev_additional_id
      : (key === 'ProgramsData') ? row?.education_program_id : null;
    if (gridId === null || gridId === undefined) {
      this.alertService.warn('No Id found for this application!')
    } else {
      const options: NgbModalOptions = { backdrop: 'static', size: 'md', centered: true, windowClass: 'custom-delete-record-modal' };
      const modalRef = this.modalService.open(ModalComponent, options);
      const sectionName =
        key === 'AcademicBackground'
          ? 'academic background record'
          : key === 'EmploymentDevHrs'
            ? 'employment professional development record'
            : key === 'AdditionalDevHrs'
              ? 'additional professional development record'
              : key === 'ProgramsData'
                ? 'program record'
                : 'record';
      const config: ModalConfig = {
        buttons: [
          { text: 'Cancel', code: 'N', btnOutline: true },
          { text: 'Delete', code: 'Y', btnOutline: false }
        ],
        heading: 'Delete Record',
        headingAlign: 'left',
        modalContent: 'Are you sure you want to delete this record? This action cannot be undone.',
        modalContentClass: 'actdelcontent',
        hasTemplate: true,
        isDangerButton: true,
        panelClass: 'lookup-act-delete-modal'
      };
      modalRef.componentInstance.modalConfig = config;
      modalRef.componentInstance.emitData.pipe(take(1)).subscribe((response: any) => {
        modalRef.close();
        if (response?.code === 'Y' || response?.confirmed === true) {
          this.deleteApI({ grid_Id: gridId, key });
        }
      });
    }
  }

  deleteApI(data) {
    this.httpService.delete(API_ENDPOINTS.USER_EDUCATOR_TAB.Deletion_across_grids, data).subscribe({
      next: (res: any) => {
        const success = res?.status === 'success' || res?.data?.success === true;
        if (success) {
          this.alertService.success(this.toastMessage['T0040'] || 'Deleted successfully.');
          this.refreshEducatorsData();
        } else {
          this.alertService.error(res?.data?.message || res?.message || 'Failed to Delete, Please try after sometime');
        }
      },
      error: (err: any) => {
        this.alertService.error(err?.error?.message || err?.message || 'Failed to Delete, Please try after sometime');
      }
    })
  }

  canShowDeleteEducationDocument(row: any): boolean {
    return true;
  }

  confirmDeleteDocument(row: any): void {
    if (false) {
      this.alertService.warn('You are not permitted to delete this document.');
      return;
    }
    const options: NgbModalOptions = { backdrop: 'static', centered: true, size: 'md', windowClass: 'custom-delete-record-modal' };
    const modalRef = this.modalService.open(ModalComponent, options);
    const config: ModalConfig = {
      buttons: [
        { text: 'Cancel', code: 'N', btnOutline: true },
        { text: 'Delete', code: 'Y', btnOutline: false }
      ],
      heading: 'Delete Document',
      headingAlign: 'left',
      modalContent: 'Are you sure you want to delete this document? This action cannot be undone.',
      modalContentClass: 'actdelcontent',
      hasTemplate: true,
      isDangerButton: true,
      panelClass: 'lookup-act-delete-modal'
    };
    modalRef.componentInstance.modalConfig = config;
    modalRef.componentInstance.emitData.pipe(take(1)).subscribe((response: any) => {
      modalRef.close();
      if (response?.code === 'Y' || response?.confirmed === true) {
        this.httpService.post(API_ENDPOINTS.EDUCATOR_DELETE_DOCUMENT, { document_id: row.document_id })
          .pipe(take(1), takeUntil(this.destroy$))
          .subscribe({
            next: (res: any) => {
              if (res?.success === false) {
                this.alertService.error(res.message || 'Failed to delete document.');
                return;
              }
              this.alertService.success(this.toastMessage['T0040'] || 'Document deleted successfully.');
              this.refreshEducatorsData();
            },
            error: () => {
              this.alertService.error('Failed to delete document. Please try again.');
            }
          });
      }
    });
  }
  // load dropdowns values for all grids
  private loadDropdownValues(): void {
    forkJoin([
      this.httpService.get('/domain/lookup?requestType=INSTITUTION LOCATION'),
      this.httpService.get('/domain/lookup?requestType=CREDENTIAL TYPE'),
      this.httpService.get('/domain/lookup?requestType=DEGREE EARNED'),
      this.httpService.get('/domain/lookup?requestType=FIELD OF STUDY'),
      this.httpService.get('/domain/lookup?requestType=DISTRICT'),
      this.httpService.get('/domain/lookup?requestType=PROF-DEV-PROVIDER'),
      this.httpService.get('/domain/lookup?requestType=ENDORSEMENT'),
      this.httpService.get('/domain/lookup?requestType=MESSAGES'),
      this.httpService.get('/domain/lookup?requestType=PLACEHOLDER MESSAGES'),
      this.httpService.get('/domain/lookup?requestType=TOAST MESSAGES'),
      this.httpService.get('/domain/lookup?requestType=GENERIC MESSAGES'),
      this.httpService.get(API_ENDPOINTS.LOOKUP_DOCUMENT_CATEGORY),
      this.httpService.get(API_ENDPOINTS.LOOKUP_DOCUMENT_TYPE),

    ]).subscribe({
      next: ((item: any) => {
        this.institutionLocationLookup = (item[0].data)
          .filter(
            lookupItem => lookupItem.value !== '<DoD Value>'
          ) || [];
        this.filteredInstitutionLocations = [...this.institutionLocationLookup];
        this.institutionLocationFilterCtrl.valueChanges.subscribe(() => this.filterInstitutionLocations());
        this.credentialTypeLookup = (item[1].data || []).sort((a: any, b: any) =>
          a.value.localeCompare(b.value)
        );
        this.filteredCredentialType = [...this.credentialTypeLookup];
        this.credentialTypeFilterCtrl.valueChanges.subscribe(() => this.filterCredentialType());
        this.degreeEarnedLookup = (item[2].data || []).sort((a: any, b: any) =>
          a.value.localeCompare(b.value)
        );
        this.filteredDegreeEarned = [...this.degreeEarnedLookup];
        this.degreeEarnedFilterCtrl.valueChanges.subscribe(() => this.filterDegreeEarned());
        this.fieldOfStudyLookup = (item[3].data || []).sort((a: any, b: any) =>
          a.value.localeCompare(b.value)
        );
        this.districtsLookup = (item[4].data || []).sort((a: any, b: any) =>
          a.value.localeCompare(b.value)
        );
        this.filteredDistrictsLookup = [...this.districtsLookup];
        this.districtsFilterCtrl.valueChanges.subscribe(() => this.filterDistricts());
        this.profDevProvidersLookup = (item[5].data || []).sort((a: any, b: any) =>
          a.value.localeCompare(b.value)
        );
        this.filteredProfDevProviders = [...this.profDevProvidersLookup];
        this.providersFilterCtrl.valueChanges.subscribe(() => this.filterProfDevProviders());
        this.studentTeachingGradeLookup =  (item[6].data || []).sort((a: any, b: any) =>
          a.value.localeCompare(b.value)
        );
        this.filteredStudentTeachingGrades = [...this.studentTeachingGradeLookup];
        this.studentTeachingGradeFilterCtrl.valueChanges.subscribe(() => this.filterStudentTeachingGrades());
        this.errorMessage = {};
        (item[7]?.data || []).forEach((msg: { key?: string; value?: string }) => {
          if (msg.key != null && msg.value !== undefined) this.errorMessage[msg.key] = msg.value;
        });
        this.placeholderMessage = {};
        (item[8]?.data || []).forEach((msg: { key?: string; value?: string }) => {
          if (msg.key != null && msg.value !== undefined) this.placeholderMessage[msg.key] = msg.value;
        });
        this.toastMessage = {};
        (item[9]?.data || []).forEach((msg: { key?: string; value?: string }) => {
          if (msg.key != null && msg.value !== undefined) this.toastMessage[msg.key] = msg.value;
        });
        this.genericMessage = {};
        (item[10]?.data || []).forEach((msg: { key?: string; value?: string }) => {
          if (msg.key != null && msg.value !== undefined) this.genericMessage[msg.key] = msg.value;
        });

        const mapLookupFull = (arr: any[]): Array<{ id: number; parentid: number | null; key: string; value: string }> =>
          (arr || []).map((x: any) => ({
            id: Number(x?.id ?? 0),
            parentid: x?.parentid != null ? Number(x.parentid) : null,
            key: String(x?.key ?? ''),
            value: String(x?.value ?? '')
          }));

        this.docCategoryOptions = mapLookupFull(item[11]?.data || []).map((x: any) => ({
          id: x.id,
          key: x.key,
          value: x.value
        }));
        this.defaultDocCategoryOptions = [...this.docCategoryOptions];
        this.allDocTypeOptions = mapLookupFull(item[12]?.data || []);
        // Chain category lookups inside the forkJoin — exactly like activities tab.
        // Load all top-level categories AND section-scoped categories for each education section.
        forkJoin({
          all: this.supportingDocLookupService.getAllTopLevelCategories(),
          academicBg: this.supportingDocLookupService.getCategoriesBySectionName('Academic Background'),
          districtCharter: this.supportingDocLookupService.getCategoriesBySectionName('District / Charter Employment'),
          additionalProfDev: this.supportingDocLookupService.getCategoriesBySectionName('Additional Professional Development'),
          programs: this.supportingDocLookupService.getCategoriesBySectionName('Programs')
        })
          .pipe(take(1), takeUntil(this.destroy$))
          .subscribe(({ all, academicBg, districtCharter, additionalProfDev, programs }) => {
            this.allSupportingDocCategories = all;
            // Merge all section-scoped options — used as fallback in label context
            this.educationSectionCategoryOptions = [
              ...academicBg,
              ...districtCharter,
              ...additionalProfDev,
              ...programs
            ];
            this.lookupsLoaded = true;
            this.rebuildEducationGridsIfReady();
          });
      })
    })

  }
  // custom form validators
  validateDateNotBeforeDob = (control: AbstractControl): ValidationErrors | null => {
    const val = control.value;
    if (!val || typeof val !== 'string' || !val.includes('/')) return null;
    const parts = val.split('/');
    if (parts.length !== 3) return null;
    const selectedDate = new Date(Number(parts[2]), Number(parts[0]) - 1, Number(parts[1]));
    if (isNaN(selectedDate.getTime())) return null;
    const dobRaw = this.educatorDashboardRow?.p_person_info?.[0]?.date_of_birth;
    if (!dobRaw) return null;
    const isoMatch = String(dobRaw).match(/(\d{4})-(\d{2})-(\d{2})/);
    const mdyMatch = String(dobRaw).match(/(\d{2})\/(\d{2})\/(\d{4})/);
    let dob: Date;
    if (isoMatch) {
      dob = new Date(Number(isoMatch[1]), Number(isoMatch[2]) - 1, Number(isoMatch[3]));
    } else if (mdyMatch) {
      dob = new Date(Number(mdyMatch[3]), Number(mdyMatch[1]) - 1, Number(mdyMatch[2]));
    } else {
      return null;
    }
    dob.setHours(0, 0, 0, 0);
    selectedDate.setHours(0, 0, 0, 0);
    if (selectedDate < dob) return { beforeDob: true };
    return null;
  };

  validateDate = (control: AbstractControl): ValidationErrors | null => {
    const val = control.value;
    if (!val) return null;

    let selectedDate: Date;

    // Expecting MM/DD/YYYY formatted string
    if (typeof val === 'string' && val.includes('/')) {
      const parts = val.split('/');
      if (parts.length !== 3) return { futureDate: true };

      const month = Number(parts[0]);
      const day = Number(parts[1]);
      const year = Number(parts[2]);

      // Basic validations
      if (
        month < 1 || month > 12 ||
        day < 1 || day > 31 ||
        year < 1900
      ) return { futureDate: true };

      // IMPORTANT: create a date without timezone issues
      selectedDate = new Date(year, month - 1, day);

      // Invalid date (e.g. Feb 30)
      if (
        selectedDate.getFullYear() !== year ||
        selectedDate.getMonth() !== (month - 1) ||
        selectedDate.getDate() !== day
      ) {
        return { futureDate: true };
      }

    } else {
      return { futureDate: true }; // force invalid for any unexpected input
    }

    // ✅ Normalize "today" to remove hours so comparisons work
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // ✅ Normalize selected date as well
    const checkDate = new Date(selectedDate);
    checkDate.setHours(0, 0, 0, 0);

    // ✅ FINAL CHECK: Is selected date in the future?
    if (checkDate.getTime() > today.getTime()) {
      return { futureDate: true };
    }

    return null;
  };


  restrictDecimals(event: Event, key: string) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    if (!/^\d*\.?\d{0,2}$/.test(value)) {
      input.value = value.slice(0, -1);
      this.AcademicBGForm.get(key)?.setValue(input.value, { emitEvent: false });
    }
  }

  restrictDecimalsForForm(event: Event, form: FormGroup, key: string) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    if (!/^\d*\.?\d{0,2}$/.test(value)) {
      input.value = value.slice(0, -1);
      form.get(key)?.setValue(input.value, { emitEvent: false });
    }
  }

  restrictExtraDecimals(event: Event, form: FormGroup, key: string) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    // Only strip if the value is numeric but has more than 2 decimal places
    const match = value.match(/^(\d*\.\d{2})\d+$/);
    if (match) {
      input.value = match[1];
      form.get(key)?.setValue(match[1], { emitEvent: true });
    }
  }

  // restrict key e in select
  preventE(event: KeyboardEvent) {
    if (['e', 'E', '+', '-'].includes(event.key)) {
      event.preventDefault();
    }
  }



  // Insert functions for table grids
  saveProfDevAdditionalHrs() {
    if(this.addtionalProfDevForm.invalid){
      this.addtionalProfDevForm.markAllAsTouched();
      this.alertService.error(this.toastMessage['T0017'] || 'Please fill in all required fields.');
      return;
    }

    if (this.isAdditionalProfDevDuplicate()) {
      this.alertService.error('Duplicate entry detected. This record already exists.');
      return;
    }
    const data = {
      ...this.addtionalProfDevForm.value,
      personId: this.personId,
      createdBy: this.getCurrentUserId(),
      createdDate: new Date().toISOString()

    }
    this.httpService.post(API_ENDPOINTS.USER_EDUCATOR_TAB.Insert_Additional_Dev_Hours, data).subscribe({
      next: (res: any) => {
        const success = res?.status === 'success' || res?.data?.success === true;
        if (success) {
          this.showAdditionalProfDevForm = false;
          this.refreshEducatorsData();
          this.resetAdditionalDevForm();
          this.alertService.success(this.toastMessage['T0005'] || 'Added successfully.');
        } else {
          this.alertService.error(res?.data?.message || res?.message || 'Failed to save, Please try after sometime!');
        }
      },
      error: (err: any) => {
        this.showAdditionalProfDevForm = false;
        this.resetAdditionalDevForm();
        this.alertService.error(err?.error?.message || err?.message || 'Failed to save, Please try after sometime!')
      }
    })

  }

  saveAcademicBGForm() {
    if (this.isEditAcademicBgModal) return;
    if(this.AcademicBGForm.invalid){
      this.AcademicBGForm.markAllAsTouched();
      this.alertService.error(this.toastMessage['T0017'] || 'Please fill in all required fields.');
       return;
    }

    if (this.isAcademicBgDuplicate()) {
      this.alertService.error('Duplicate entry detected. This record already exists.');
      return;
    }

    const formValue = this.AcademicBGForm.value;
    const data = {
      ...formValue,
      credit_earned: formValue.credit_earned != null ? parseFloat(formValue.credit_earned).toFixed(2) : formValue.credit_earned,
      personId: this.personId,
      updatedBy : this.getCurrentUserId()
    }
    this.httpService.post(API_ENDPOINTS.USER_EDUCATOR_TAB.Insert_Academic_BgData, data).subscribe({
      next: (res: any) => {
        const success = res?.status === 'success' || res?.data?.success === true;
        if (success) {
          this.showAcademicBGForm = false;
          this.refreshEducatorsData();
          this.resetAcademicBgForm();
          this.alertService.success(this.toastMessage['T0005'] || 'Added successfully.');
          const savedCredKey = data.credential_type;
          const credLookupItem = this.credentialTypeLookup.find(item => String(item.key) === String(savedCredKey));
          if (credLookupItem?.value?.toLowerCase().trim() === 'high school diploma or equivalent') {
            const uploads = Array.isArray(this.educatorDashboardRow?.['p_profile_upload'])
              ? this.educatorDashboardRow['p_profile_upload'] : [];
            const hasHighSchoolDoc = uploads.some(doc =>
              String(doc.cd_document_category || '').trim() === '10' &&
              (doc.file_name || doc.file_hash)
            );
            if (hasHighSchoolDoc) {
              this.triggerAutoTranscriptUpdate();
            }
          }
        } else {
          this.alertService.error(res?.data?.message || res?.message || 'Failed to save, Please try after sometime!');
        }
      },
      error: (err: any) => {
        this.alertService.error(err?.error?.message || err?.message || 'Failed to save, Please try after sometime!');
      }
    })
  }


  updateProfDevHrs() {
    if(this.profDevCourseworkForm.invalid){
      this.profDevCourseworkForm.markAllAsTouched();
      this.alertService.error(this.toastMessage['T0017'] || 'Please fill in all required fields.');
      return;
    }
    const data = {
      ...this.profDevCourseworkForm.getRawValue(),
      personId: Number(this.personId)
    }
    this.httpService.post(API_ENDPOINTS.USER_EDUCATOR_TAB.UPDATE_PROF_DEV_HOURS, data).subscribe({
      next: (res: any) => {
        const success = res?.status === 'success' || res?.data?.success === true;
        if (success) {
          this.alertService.success(this.toastMessage['T0020'] || 'Updated Successfully');
          this.profDevCourseworkOriginalValue = String(this.profDevCourseworkForm.get('sem_credits_earned')?.value ?? '');
          this.refreshEducatorsData();
        } else {
          this.alertService.error(res?.data?.message || res?.message || 'Failed to update, Please try after sometime!');
        }
      },
      error:(err: any)=>{
        this.alertService.error(err?.error?.message || err?.message || 'Failed to update, Please try after sometime!')
      }
    })
  }

  showProfDevCoursework() {
    this.showProfDevCollegeSection = !this.showProfDevCollegeSection;
  }

  showProfDevEmploymentSection() {
    this.showProfDevEmpSection = !this.showProfDevEmpSection
  }

  // ── Supporting Documents: View / Download / Upload ──

  supportingDocumentHasValidId(row: { document_id?: number | null }): boolean {
    const n = Number(row?.document_id ?? (row as any)?.profile_document_upload_id ?? (row as any)?.documentId);
    return Number.isFinite(n) && n > 0;
  }

  viewSupportingDocument(row: any): void {
    const id = Number(row?.document_id ?? row?.profile_document_upload_id ?? row?.documentId);
    if (!Number.isFinite(id) || id <= 0) {
      this.alertService.error('Document information is missing');
      return;
    }
    this.httpService
      .post(API_ENDPOINTS.EDUCATOR_COMMUNICATION_DOWNLOAD, {
        profile_document_upload_id: id
      })
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          const fileUrl = resolveEducatorDocumentFileUrl(response);
          if (!fileUrl) {
            this.alertService.error('Failed to retrieve document URL');
            return;
          }
          this.documentPreviewModal.openFromUrl(fileUrl, row.file_name);
        },
        error: () => {
          this.alertService.error('Failed to view document. Please try again.');
        }
      });
  }

  downloadSupportingDocument(row: any): void {
    const id = Number(row?.document_id ?? row?.profile_document_upload_id ?? row?.documentId);
    if (!Number.isFinite(id) || id <= 0) {
      this.alertService.error('Document information is missing');
      return;
    }
    this.httpService
      .post(API_ENDPOINTS.EDUCATOR_COMMUNICATION_DOWNLOAD, {
        profile_document_upload_id: id
      })
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          const fileUrl = this.resolveSupportingDocumentFileUrl(response);
          if (!fileUrl) {
            this.alertService.error('Failed to download document');
            return;
          }
          fetch(fileUrl)
            .then(res => res.blob())
            .then(blob => {
              const fileName = String(row.file_name || `document_${id}`);
              FileSaver.saveAs(blob, fileName);
              //this.alertService.success('Document downloaded successfully.');
            })
            .catch(() => {
              this.alertService.error('Failed to download document file');
            });
        },
        error: () => {
          this.alertService.error('Failed to download document. Please try again.');
        }
      });
  }
getSelectLabel(
  key: any,
  options: { key: any; value: string }[]
): string {
  if (!key || !options?.length) return '';

  const found = options.find(o => String(o.key) === String(key));
  if (!found?.value) return '';

  const trimmedLabel = found.value.trim();
  const wordCount = trimmedLabel.split(/\s+/).length;
  const charCount = trimmedLabel.length;

  return charCount > 21 ? found.value : '';
}


  private resolveSupportingDocumentFileUrl(response: any): string | null {
    return (
      response?.data?.data?.p_document_blob?.file_url ||
      response?.data?.data?.p_document_blob?.fileUrl ||
      response?.data?.data?.p_document_blob?.strfileHash ||
      response?.data?.data?.p_document_blob?.file_hash ||
      response?.data?.data?.p_document_blob?.fileHash ||
      response?.data?.file_url ||
      response?.data?.fileUrl ||
      response?.data?.url ||
      response?.file_url ||
      response?.fileUrl ||
      null
    );
  }
  hasValidDocumentId(row: any): boolean {
    const value = row?.['document_id'] ?? row?.['profile_document_upload_id'] ?? row?.['documentId'];
    const numeric = Number(value);
    return Number.isFinite(numeric) && numeric > 0;
  }

  private loadSemesterCreditMultiplier(): void {
    this.manageProfileService.getBusinessRuleByKey('Application', 'prof_dev_clock_hours')
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response?.data?.data?.intValue) {
            this.semesterCreditMultiplier = response.data.data.intValue;
            // Recalculate prof_dev_hrs now that the correct multiplier is available,
            // in case sem_credits_earned was already set from DB before this call returned.
            const currentCredits = this.profDevCourseworkForm?.get('sem_credits_earned')?.value;
            if (currentCredits != null && currentCredits !== '') {
              this.profDevCourseworkForm.get('prof_dev_hrs')?.setValue(
                parseFloat((Number(currentCredits) * this.semesterCreditMultiplier).toFixed(2)),
                { emitEvent: false }
              );
            }
          }
        },
        error: (error) => {
          console.error('[LookupUserEducationTab] Error fetching semester credit hours rule:', error);
        }
      });
  }

}
